import React, { createContext, useContext, useState, useEffect } from 'react';

export const LANGUAGES = {
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  it: 'Italiano',
  pt: 'Português',
  nl: 'Nederlands',
  pl: 'Polski',
  tr: 'Türkçe',
  ru: 'Русский',
  zh: '中文',
  ja: '日本語',
};

export const LANGUAGE_FLAGS = {
  de: '🇩🇪',
  en: '🇬🇧',
  es: '🇪🇸',
  fr: '🇫🇷',
  it: '🇮🇹',
  pt: '🇵🇹',
  nl: '🇳🇱',
  pl: '🇵🇱',
  tr: '🇹🇷',
  ru: '🇷🇺',
  zh: '🇨🇳',
  ja: '🇯🇵',
};

const translations = {
  de: {
    // --- Landing (auto-added) ---
    landingTag: 'Prognosen unter Freunden',
    landingHead: 'Tippt gemeinsam. Gewinnt gemeinsam.',
    landingSub: 'Scherenmarket ist eure private Prognose-Plattform. Tritt einer Organisation bei, erstelle Ja/Nein-Wetten und miss dich mit Freunden.',
    landingReg: 'Kostenlos registrieren',
    landingLogin: 'Anmelden',
    landingHaveAcc: 'Schon dabei?',
    f1t: 'Private Organisationen',
    f1d: 'Eigene Räume – nur deine Gruppe sieht eure Wetten.',
    f2t: 'Wetten erstellen',
    f2d: 'Ja/Nein-Prognosen zu allem – von der Uni bis zur Bundesliga.',
    f3t: 'Fair abrechnen',
    f3d: 'Spielgeld oder echte PayPal-Abrechnung – ihr entscheidet.',
    landingFooter: 'Prognosemarkt für Freundesgruppen',
    // --- Organizations & Announcements (auto-added) ---
    orgsTitle: 'Organisationen',
    orgsSubtitle: 'Tritt einer Organisation bei, um deren Wetten zu sehen und mitzumachen. Du kannst in mehreren gleichzeitig sein.',
    orgsSearch: 'Organisation suchen…',
    orgsCreateBtn: 'Erstellen',
    orgsNoneFound: 'Keine Organisation gefunden.',
    orgMemberBadge: 'Mitglied',
    orgRequestedBadge: 'Anfrage gestellt',
    orgAcceptedBadge: 'Angenommen',
    orgHostBadge: 'Host',
    orgMembersWord: 'Mitglieder',
    orgMemberWord: 'Mitglied',
    orgViewMembers: 'ansehen',
    orgJoinBtn: 'Beitreten',
    orgJoinCode: 'Beitrittscode',
    orgEnterCode: 'Bitte Beitrittscode eingeben.',
    orgRequestJoin: 'Beitritt anfragen',
    orgRequestsBtn: 'Anfragen',
    orgEditBtn: 'Bearbeiten',
    orgLeaveBtn: 'Verlassen',
    orgLeaveTitle: 'Organisation verlassen?',
    orgLeaveDesc: 'Du siehst deren Wetten dann nicht mehr und musst ggf. neu beitreten.',
    orgJoined: 'Organisation beigetreten.',
    orgJoinFailed: 'Beitritt fehlgeschlagen.',
    orgRequestSent: 'Beitrittsanfrage gestellt – der Host muss sie bestätigen.',
    orgRequestFailed: 'Anfrage fehlgeschlagen.',
    orgLeft: 'Organisation verlassen.',
    orgLeaveFailed: 'Austritt fehlgeschlagen.',
    orgLoadFailed: 'Organisationen konnten nicht geladen werden.',
    orgRequestsLoadFailed: 'Anfragen konnten nicht geladen werden.',
    orgApprovedToast: 'Beitritt bestätigt.',
    orgRejectedToast: 'Anfrage abgelehnt.',
    orgActionFailed: 'Aktion fehlgeschlagen.',
    orgCreateTitle: 'Organisation erstellen',
    orgCreateDesc: 'Du wirst automatisch Host deiner neuen Organisation.',
    orgNameLabel: 'Name',
    orgNameRequired: 'Bitte einen Namen angeben.',
    orgDescLabel: 'Beschreibung',
    orgDescPlaceholder: 'Worum geht\'s?',
    orgImageLabel: 'Bild-URL',
    orgImageOptional: 'Bild-URL (optional)',
    orgPolicyLabel: 'Beitritt',
    policyBoth: 'Code oder Anfrage',
    policyCode: 'Nur per Code',
    policyRequest: 'Nur per Anfrage',
    orgPaypalBilling: 'PayPal-Abrechnung',
    orgPlayMoney: 'Spielgeld',
    orgCreated: 'Organisation erstellt.',
    orgCreateFailed: 'Erstellen fehlgeschlagen.',
    orgUpdated: 'Organisation aktualisiert.',
    orgSaveFailed: 'Speichern fehlgeschlagen.',
    orgEditTitle: 'Organisation bearbeiten',
    orgMembersTitle: 'Mitglieder',
    orgMembersLoadFailed: 'Mitglieder konnten nicht geladen werden.',
    orgRemoveMemberTitle: 'Mitglied entfernen?',
    orgRemoveMemberDesc: 'Die Person verliert den Zugang zu dieser Organisation.',
    orgMemberRemoved: 'Mitglied entfernt.',
    orgRemoveFailed: 'Entfernen fehlgeschlagen.',
    orgNoRequests: 'Keine offenen Anfragen.',
    approveBtn: 'Annehmen',
    rejectBtn: 'Ablehnen',
    removeBtn: 'Entfernen',
    orgAcceptedInfo: 'Deine Anfrage wurde angenommen.',
    orgFinishPaypal: 'Hinterlege deinen PayPal-Link, um den Beitritt abzuschließen.',
    orgFinishJoin: 'Schließe den Beitritt ab.',
    orgJoinWithPaypal: 'Mit PayPal beitreten',
    orgCompleteJoin: 'Beitritt abschließen',
    orgPaypalRequired: 'PayPal-Link erforderlich.',
    announcementClose: 'Ankündigung schließen',
    coins: '€',
    balance: 'Gewinn / Verlust',
    netProfitLoss: 'Gewinn / Verlust',
    loading: 'Lädt...',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    save: 'Speichern',
    saving: 'Speichert...',
    saveChanges: 'Änderungen speichern',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    back: 'Zurück',
    viewAll: 'Alle anzeigen',
    search: 'Suchen',
    add: 'Hinzufügen',
    remove: 'Entfernen',
    create: 'Erstellen',
    previous: 'Vorherige',
    next: 'Nächste',
    welcomeBack: 'Scherenmarket',
    signInToAccount: 'Melde dich an',
    email: 'E-Mail oder Benutzername',
    password: 'Passwort',
    signIn: 'Anmelden',
    signingIn: 'Anmeldung...',
    noAccount: 'Noch kein Konto?',
    createOne: 'Erstelle eins',
    createAccount: 'Konto erstellen',
    joinScherenmarket: 'Tritt bei',
    username: 'Benutzername',
    confirmPassword: 'Passwort bestätigen',
    creatingAccount: 'Konto wird erstellt...',
    hasAccount: 'Bereits ein Konto?',
    startWithEuro: 'Du startest mit',
    canGoNegative: 'Du startest bei 0 € - wette so viel du willst!',
    startingCapital: 'Startkapital: 0 €',
    markets: 'Wetten',
    dashboard: 'Dashboard',
    profile: 'Profil',
    logout: 'Abmelden',
    language: 'Sprache',
    friends: 'Freunde',
    groups: 'Gruppen',
    toggleTheme: 'Design anpassen',
    settlements: 'Zahlungen & Gewinne',
    toPay: 'Zu bezahlen',
    toConfirm: 'Erhalt bestätigen',
    wonBetsOverview: 'Gewonnene Wetten',
    settlementHistory: 'Zahlungsverlauf',
    noPayoutsToPay: 'Keine offenen Wettschulden. Gut gemacht!',
    noPayoutsToConfirm: 'Keine ausstehenden Zahlungen zu bestätigen.',
    noWonBetsYet: 'Noch keine Wetten gewonnen.',
    noPayoutHistory: 'Noch kein Zahlungsverlauf vorhanden.',
    amountToPay: 'Betrag',
    payee: 'Empfänger',
    payer: 'Sender',
    openPaypal: 'Per PayPal bezahlen',
    confirmReceipt: 'Erhalt bestätigen',
    receiptConfirmed: 'Erhalt bestätigt!',
    statusPending: 'Ausstehend',
    statusConfirmed: 'Bestätigt',
    copied: 'Kopiert!',
    copyInfo: 'Daten kopieren',
    pendingSettlementsAlert: 'Du hast offene Abrechnungen! Bitte überprüfe deine Zahlungen.',
    welcomeBackUser: 'Willkommen zurück,',
    tradingOverview: 'Hier ist dein Überblick',
    createMarket: 'Wette erstellen',
    activeBets: 'Aktive Wetten',
    activeWager: 'Offener Einsatz',
    totalBets: 'Gesamt Wetten',
    winRate: 'Gewinnrate',
    hotMarkets: 'Aktuelle Wetten',
    yourOpenBets: 'Deine offenen Wetten',
    noOpenBets: 'Keine offenen Wetten. Finde eine Wette!',
    leaderboard: 'Bestenliste',
    topTraders: 'Top Tipper',
    bottomTraders: 'Bottom Tipper',
    browseMarkets: 'Wetten',
    browseBet: 'Wette auf Vorhersagen',
    searchMarkets: 'Wetten suchen...',
    all: 'Alle',
    noMarketsFound: 'Keine Wetten gefunden',
    noMarketsMatch: 'Keine Wetten entsprechen',
    beFirstToCreate: 'Sei der Erste und erstelle eine Wette!',
    backToMarkets: 'Zurück zu Wetten',
    marketNotFound: 'Wette nicht gefunden',
    by: 'von',
    ends: 'Endet',
    bets: 'Wetten',
    pool: 'Pool',
    timeRemaining: 'Verbleibende Zeit',
    days: 'Tage',
    hours: 'Stunden',
    mins: 'Min',
    secs: 'Sek',
    yes: 'JA',
    no: 'NEIN',
    betYes: 'WETTE JA',
    betNo: 'WETTE NEIN',
    resolveMarket: 'Wette abschließen',
    cancelMarket: 'Wette abbrechen',
    cancelMarketConfirm: 'Wette wirklich abbrechen? Alle Einsätze werden erstattet.',
    yourBets: 'Deine Wetten',
    pending: 'Ausstehend',
    won: 'Gewonnen',
    lost: 'Verloren',
    refunded: 'Erstattet',
    potential: 'Potenzial',
    ended: 'Beendet',
    visibility: 'Sichtbarkeit',
    visibilityPublic: 'Öffentlich',
    visibilityEmailDomain: 'Nur bestimmte E-Mail-Domain',
    visibilitySpecificUsers: 'Nur bestimmte Nutzer',
    visibilityGroup: 'Nur Gruppe',
    emailDomain: 'E-Mail-Domain (z.B. stud.uni-goettingen.de)',
    selectUsers: 'Nutzer auswählen',
    selectGroup: 'Gruppe auswählen',
    category: 'Kategorie',
    categories: 'Kategorien',
    noCategory: 'Keine Kategorie',
    createCategory: 'Kategorie erstellen',
    achievements: 'Erfolge',
    noAchievements: 'Noch keine Erfolge freigeschaltet.',
    awardedAt: 'Erhalten am',
    categoryName: 'Kategorie-Name',
    tagUsers: 'Nutzer taggen',
    taggedUsers: 'Getaggte Nutzer',
    searchUsers: 'Nutzer suchen...',
    userSearch: 'Nutzer suchen',
    userProfile: 'Nutzerprofil',
    memberSince: 'Mitglied seit',
    recentBets: 'Letzte Wetten',
    friendsList: 'Freundesliste',
    friendRequests: 'Freundschaftsanfragen',
    addFriend: 'Als Freund hinzufügen',
    removeFriend: 'Freund entfernen',
    acceptRequest: 'Annehmen',
    rejectRequest: 'Ablehnen',
    requestSent: 'Anfrage gesendet',
    noFriends: 'Noch keine Freunde',
    noPendingRequests: 'Keine ausstehenden Anfragen',
    editNickname: 'Spitznamen bearbeiten',
    setNickname: 'Spitznamen festlegen',
    nickname: 'Spitzname',
    nicknameUpdated: 'Spitzname erfolgreich aktualisiert',
    myGroups: 'Meine Gruppen',
    createGroup: 'Gruppe erstellen',
    groupName: 'Gruppenname',
    groupDescription: 'Beschreibung',
    groupMembers: 'Mitglieder',
    addMembers: 'Mitglieder hinzufügen',
    leaveGroup: 'Gruppe verlassen',
    noGroups: 'Noch keine Gruppen',
    copyInviteLink: 'Einladungslink kopieren',
    copyLinkManually: 'Kopiere den Link manuell:',
    close: 'Schließen',
    inviteLinkCopied: 'Einladungslink in die Zwischenablage kopiert!',
    failedToCopyInviteLink: 'Fehler beim Kopieren des Einladungslinks',
    groupJoined: 'Gruppe erfolgreich beigetreten!',
    joiningGroup: 'Trete Gruppe bei...',
    invalidInviteLink: 'Ungültiger Einladungslink',
    alreadyMember: 'Du bist bereits Mitglied dieser Gruppe',
    error: 'Fehler',
    backToFriends: 'Zurück zu Freunde',
    placeBet: 'Wette platzieren',
    betAmount: 'Wetteinsatz',
    yourBalance: 'Dein Gewinn/Verlust',
    placingBet: 'Wette wird platziert...',
    betOn: 'Wette auf',
    selectWinner: 'Wähle das Gewinnerergebnis. Diese Aktion kann nicht rückgängig gemacht werden.',
    yesWon: 'JA hat gewonnen',
    noWon: 'NEIN hat gewonnen',
    marketResolved: 'Wette abgeschlossen',
    marketCancelled: 'Wette abgebrochen',
    winners: 'Gewinner',
    totalPayout: 'Gesamtauszahlung',
    winnersList: 'Gewinnerliste',
    noWinners: 'Keine Gewinner',
    payout: 'Auszahlung',
    createAMarket: 'Wette erstellen',
    createYesNo: 'Erstelle eine Ja/Nein Vorhersage für andere zum Wetten',
    questionTitle: 'Frage / Titel',
    questionPlaceholder: 'Wird Bitcoin bis Ende 2024 100k erreichen?',
    descriptionOptional: 'Beschreibung (Optional)',
    descriptionPlaceholder: 'Füge mehr Kontext zu dieser Vorhersage hinzu...',
    endDateTime: 'Enddatum & Uhrzeit',
    pickDateTime: 'Datum und Uhrzeit wählen',
    marketWillClose: 'Die Wette wird zu diesem Zeitpunkt geschlossen',
    tipsTitle: 'Tipps für eine gute Wette:',
    tip1: 'Stelle die Frage klar und eindeutig',
    tip2: 'Setze ein realistisches Enddatum',
    tip3: 'Füge eine Beschreibung für Kontext hinzu',
    tip4: 'Du bist verantwortlich für die Auflösung der Wette',
    creating: 'Erstelle...',
    transactions: 'Transaktionen',
    betHistory: 'Wettverlauf',
    noBetsYet: 'Noch keine Wetten. Starte jetzt!',
    noTransactions: 'Noch keine Transaktionen.',
    balanceOverTime: 'Gewinn/Verlust über Zeit',
    betResults: 'Wett-Ergebnisse',
    statusOpen: 'Offen',
    statusClosed: 'Geschlossen',
    statusResolved: 'Abgeschlossen',
    statusCancelled: 'Abgebrochen',
    loginFailed: 'Anmeldung fehlgeschlagen',
    registrationFailed: 'Registrierung fehlgeschlagen',
    passwordsNoMatch: 'Passwörter stimmen nicht überein',
    passwordTooShort: 'Passwort muss mindestens 6 Zeichen haben',
    invalidBetAmount: 'Ungültiger Wetteinsatz',
    marketCreationFailed: 'Wette konnte nicht erstellt werden',
    betPlacementFailed: 'Wette konnte nicht platziert werden',
    welcomeMessage: 'Willkommen zurück!',
    accountCreated: 'Willkommen bei Scherenmarket!',
    marketCreated: 'Wette erfolgreich erstellt!',
    betPlaced: 'Wette platziert',
    marketResolvedSuccess: 'Wette erfolgreich abgeschlossen',
    marketCancelledSuccess: 'Wette abgebrochen, Einsätze erstattet',
    friendRequestSent: 'Freundschaftsanfrage gesendet',
    friendRequestAccepted: 'Freundschaftsanfrage angenommen',
    friendRemoved: 'Freund entfernt',
    groupCreated: 'Gruppe erstellt',
    categoryCreated: 'Kategorie erstellt',
    isTieredBet: 'Staffelungswette erstellen',
    tieredOptions: 'Optionen für Staffelungswette',
    titleTemplate: 'Titel-Vorlage (Nutze (WERT) als Platzhalter)',
    titleTemplatePlaceholder: 'Wird der Bitcoin über (WERT) € sein?',
    thresholdMode: 'Eingabemodus für Schwellenwerte',
    thresholdModeRange: 'Bereich (Start, Ende, Schrittweite)',
    thresholdModeManual: 'Manuelle Liste (Kommagetrennt)',
    startValue: 'Startwert',
    endValue: 'Endwert',
    stepSize: 'Schrittweite / Intervall',
    manualThresholds: 'Schwellenwerte (z.B. 2000, 5000, 10000)',
    manualThresholdsPlaceholder: 'Gib Schwellenwerte kommagetrennt ein...',
    invalidThresholds: 'Bitte gib gültige Schwellenwerte ein.',
    tieredMarkets: 'Schwellenwerte in dieser Staffelung',
    threshold: 'Schwelle',
    currentTier: 'Aktuelle Stufe',
    minBetAmount: 'Mindesteinsatz (€)',
    minBetAmountPlaceholder: 'z.B. 5',
    minBetAmountHint: 'Der Ersteller kann festlegen, ab welchem Betrag Wetten starten. Maximal 50 €.',
    maxBetError: 'Der Wetteinsatz darf nicht höher als 50,00 € sein.',
    staggerDeadlines: 'Deadlines staffeln',
    staggerInterval: 'Staffelungs-Intervall',
    tiersPreview: 'Stufen-Vorschau',
    sharedDeadline: 'Gemeinsame Deadline',
    hourStagger: '+1 Stunde pro Stufe',
    dayStagger: '+1 Tag pro Stufe',
    weekStagger: '+1 Woche pro Stufe',
    monthStagger: '+1 Monat pro Stufe',
    yearStagger: '+1 Jahr pro Stufe',
    customStagger: 'Individuelle Anpassung',
  },
  en: {
    // --- Landing (auto-added) ---
    landingTag: 'Predictions among friends',
    landingHead: 'Predict together. Win together.',
    landingSub: 'Scherenmarket is your private prediction platform. Join an organization, create yes/no markets and compete with friends.',
    landingReg: 'Sign up free',
    landingLogin: 'Log in',
    landingHaveAcc: 'Already here?',
    f1t: 'Private organizations',
    f1d: 'Your own spaces – only your group sees your markets.',
    f2t: 'Create markets',
    f2d: 'Yes/no predictions on anything – from campus to the league.',
    f3t: 'Settle fairly',
    f3d: 'Play money or real PayPal settlement – you decide.',
    landingFooter: 'Prediction market for friend groups',
    // --- Organizations & Announcements (auto-added) ---
    orgsTitle: 'Organizations',
    orgsSubtitle: 'Join an organization to see and take part in its markets. You can be in several at once.',
    orgsSearch: 'Search organizations…',
    orgsCreateBtn: 'Create',
    orgsNoneFound: 'No organization found.',
    orgMemberBadge: 'Member',
    orgRequestedBadge: 'Request sent',
    orgAcceptedBadge: 'Accepted',
    orgHostBadge: 'Host',
    orgMembersWord: 'members',
    orgMemberWord: 'member',
    orgViewMembers: 'view',
    orgJoinBtn: 'Join',
    orgJoinCode: 'Join code',
    orgEnterCode: 'Please enter a join code.',
    orgRequestJoin: 'Request to join',
    orgRequestsBtn: 'Requests',
    orgEditBtn: 'Edit',
    orgLeaveBtn: 'Leave',
    orgLeaveTitle: 'Leave organization?',
    orgLeaveDesc: 'You will no longer see its markets and may need to rejoin.',
    orgJoined: 'Joined the organization.',
    orgJoinFailed: 'Failed to join.',
    orgRequestSent: 'Join request sent – the host must approve it.',
    orgRequestFailed: 'Request failed.',
    orgLeft: 'Left the organization.',
    orgLeaveFailed: 'Failed to leave.',
    orgLoadFailed: 'Could not load organizations.',
    orgRequestsLoadFailed: 'Could not load requests.',
    orgApprovedToast: 'Join approved.',
    orgRejectedToast: 'Request rejected.',
    orgActionFailed: 'Action failed.',
    orgCreateTitle: 'Create organization',
    orgCreateDesc: 'You will automatically become the host of your new organization.',
    orgNameLabel: 'Name',
    orgNameRequired: 'Please enter a name.',
    orgDescLabel: 'Description',
    orgDescPlaceholder: 'What is it about?',
    orgImageLabel: 'Image URL',
    orgImageOptional: 'Image URL (optional)',
    orgPolicyLabel: 'Joining',
    policyBoth: 'Code or request',
    policyCode: 'Code only',
    policyRequest: 'Request only',
    orgPaypalBilling: 'PayPal settlement',
    orgPlayMoney: 'Play money',
    orgCreated: 'Organization created.',
    orgCreateFailed: 'Failed to create.',
    orgUpdated: 'Organization updated.',
    orgSaveFailed: 'Failed to save.',
    orgEditTitle: 'Edit organization',
    orgMembersTitle: 'Members',
    orgMembersLoadFailed: 'Could not load members.',
    orgRemoveMemberTitle: 'Remove member?',
    orgRemoveMemberDesc: 'This person will lose access to this organization.',
    orgMemberRemoved: 'Member removed.',
    orgRemoveFailed: 'Failed to remove.',
    orgNoRequests: 'No open requests.',
    approveBtn: 'Approve',
    rejectBtn: 'Reject',
    removeBtn: 'Remove',
    orgAcceptedInfo: 'Your request was accepted.',
    orgFinishPaypal: 'Add your PayPal link to complete joining.',
    orgFinishJoin: 'Complete your join.',
    orgJoinWithPaypal: 'Join with PayPal',
    orgCompleteJoin: 'Complete join',
    orgPaypalRequired: 'PayPal link required.',
    announcementClose: 'Dismiss announcement',
    coins: '€',
    balance: 'Profit / Loss',
    netProfitLoss: 'Profit / Loss',
    loading: 'Loading...',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    saving: 'Saving...',
    saveChanges: 'Save Changes',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    viewAll: 'View all',
    search: 'Search',
    add: 'Add',
    remove: 'Remove',
    create: 'Create',
    previous: 'Previous',
    next: 'Next',
    welcomeBack: 'Scherenmarket',
    signInToAccount: 'Sign in',
    email: 'Email or Username',
    password: 'Password',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    noAccount: 'Don',
    createOne: 'Create one',
    createAccount: 'Create Account',
    joinScherenmarket: 'Join',
    username: 'Username',
    confirmPassword: 'Confirm Password',
    creatingAccount: 'Creating account...',
    hasAccount: 'Already have an account?',
    startWithEuro: 'You start with',
    canGoNegative: 'You start at 0 € - bet as much as you want!',
    startingCapital: 'Starting Capital: 0 €',
    markets: 'Markets',
    dashboard: 'Dashboard',
    profile: 'Profile',
    logout: 'Logout',
    language: 'Language',
    friends: 'Friends',
    groups: 'Groups',
    toggleTheme: 'Toggle Theme',
    settlements: 'Payments & Winnings',
    toPay: 'To Pay',
    toConfirm: 'Confirm Receipt',
    wonBetsOverview: 'Won Bets',
    settlementHistory: 'Payment History',
    noPayoutsToPay: 'No outstanding bet debts. Well done!',
    noPayoutsToConfirm: 'No pending payments to confirm.',
    noWonBetsYet: 'No won bets yet.',
    noPayoutHistory: 'No payment history yet.',
    amountToPay: 'Amount',
    payee: 'Payee',
    payer: 'Payer',
    openPaypal: 'Pay with PayPal',
    confirmReceipt: 'Confirm Receipt',
    receiptConfirmed: 'Receipt confirmed!',
    statusPending: 'Pending',
    statusConfirmed: 'Confirmed',
    copied: 'Copied!',
    copyInfo: 'Copy Info',
    pendingSettlementsAlert: 'You have pending settlements! Please check your payments.',
    welcomeBackUser: 'Welcome back,',
    tradingOverview: 'Here',
    createMarket: 'Create Market',
    activeBets: 'Active Bets',
    activeWager: 'Active Wager',
    totalBets: 'Total Bets',
    winRate: 'Win Rate',
    hotMarkets: 'Hot Markets',
    yourOpenBets: 'Your Open Bets',
    noOpenBets: 'No open bets. Find a market to start trading!',
    leaderboard: 'Leaderboard',
    topTraders: 'Top Traders',
    bottomTraders: 'Bottom Traders',
    browseMarkets: 'Markets',
    browseBet: 'Browse and bet on predictions',
    searchMarkets: 'Search markets...',
    all: 'All',
    noMarketsFound: 'No markets found',
    noMarketsMatch: 'No markets match',
    beFirstToCreate: 'Be the first to create a market!',
    backToMarkets: 'Back to Markets',
    marketNotFound: 'Market not found',
    by: 'by',
    ends: 'Ends',
    bets: 'bets',
    pool: 'pool',
    timeRemaining: 'Time Remaining',
    days: 'Days',
    hours: 'Hours',
    mins: 'Mins',
    secs: 'Secs',
    yes: 'YES',
    no: 'NO',
    betYes: 'BET YES',
    betNo: 'BET NO',
    resolveMarket: 'Resolve Market',
    cancelMarket: 'Cancel Market',
    cancelMarketConfirm: 'Really cancel this market? All bets will be refunded.',
    yourBets: 'Your Bets',
    pending: 'pending',
    won: 'won',
    lost: 'lost',
    refunded: 'refunded',
    potential: 'Potential',
    ended: 'Ended',
    visibility: 'Visibility',
    visibilityPublic: 'Public',
    visibilityEmailDomain: 'Email domain only',
    visibilitySpecificUsers: 'Specific users only',
    visibilityGroup: 'Group only',
    emailDomain: 'Email domain (e.g., stud.uni-goettingen.de)',
    selectUsers: 'Select users',
    selectGroup: 'Select group',
    category: 'Category',
    categories: 'Categories',
    noCategory: 'No category',
    createCategory: 'Create Category',
    achievements: 'Achievements',
    noAchievements: 'No achievements unlocked yet.',
    awardedAt: 'Awarded on',
    categoryName: 'Category name',
    tagUsers: 'Tag users',
    taggedUsers: 'Tagged users',
    searchUsers: 'Search users...',
    userSearch: 'Search Users',
    userProfile: 'User Profile',
    memberSince: 'Member since',
    recentBets: 'Recent Bets',
    friendsList: 'Friends List',
    friendRequests: 'Friend Requests',
    addFriend: 'Add Friend',
    removeFriend: 'Remove Friend',
    acceptRequest: 'Accept',
    rejectRequest: 'Reject',
    requestSent: 'Request sent',
    noFriends: 'No friends yet',
    noPendingRequests: 'No pending requests',
    editNickname: 'Edit Nickname',
    setNickname: 'Set Nickname',
    nickname: 'Nickname',
    nicknameUpdated: 'Nickname updated successfully',
    myGroups: 'My Groups',
    createGroup: 'Create Group',
    groupName: 'Group name',
    groupDescription: 'Description',
    groupMembers: 'Members',
    addMembers: 'Add members',
    leaveGroup: 'Leave group',
    noGroups: 'No groups yet',
    copyInviteLink: 'Copy invite link',
    copyLinkManually: 'Copy link manually:',
    close: 'Close',
    inviteLinkCopied: 'Invite link copied to clipboard!',
    failedToCopyInviteLink: 'Failed to copy invite link',
    groupJoined: 'Successfully joined group!',
    joiningGroup: 'Joining group...',
    invalidInviteLink: 'Invalid invite link',
    alreadyMember: 'You are already a member of this group',
    error: 'Error',
    backToFriends: 'Back to Friends',
    placeBet: 'Place Bet',
    betAmount: 'Bet Amount',
    yourBalance: 'Your Profit/Loss',
    placingBet: 'Placing...',
    betOn: 'Bet on',
    selectWinner: 'Select the winning outcome. This action cannot be undone.',
    yesWon: 'YES Won',
    noWon: 'NO Won',
    marketResolved: 'Market Resolved',
    marketCancelled: 'Market Cancelled',
    winners: 'Winners',
    totalPayout: 'Total Payout',
    winnersList: 'Winners List',
    noWinners: 'No winners',
    payout: 'Payout',
    createAMarket: 'Create a Market',
    createYesNo: 'Create a yes/no prediction market for others to bet on',
    questionTitle: 'Question / Title',
    questionPlaceholder: 'Will Bitcoin reach $100k by end of 2024?',
    descriptionOptional: 'Description (Optional)',
    descriptionPlaceholder: 'Add more context about this prediction...',
    endDateTime: 'End Date & Time',
    pickDateTime: 'Pick date and time',
    marketWillClose: 'The market will close at this time',
    tipsTitle: 'Tips for a good market:',
    tip1: 'Make the question clear and unambiguous',
    tip2: 'Set a realistic end date',
    tip3: 'Add description for context',
    tip4: 'You',
    creating: 'Creating...',
    transactions: 'Transactions',
    betHistory: 'Bet History',
    noBetsYet: 'No bets yet. Start trading!',
    noTransactions: 'No transactions yet.',
    balanceOverTime: 'Profit/Loss Over Time',
    betResults: 'Bet Results',
    statusOpen: 'Open',
    statusClosed: 'Closed',
    statusResolved: 'Resolved',
    statusCancelled: 'Cancelled',
    loginFailed: 'Login failed',
    registrationFailed: 'Registration failed',
    passwordsNoMatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters',
    invalidBetAmount: 'Invalid bet amount',
    marketCreationFailed: 'Failed to create market',
    betPlacementFailed: 'Failed to place bet',
    welcomeMessage: 'Welcome back!',
    accountCreated: 'Welcome to Scherenmarket!',
    marketCreated: 'Market created successfully!',
    betPlaced: 'Bet placed',
    marketResolvedSuccess: 'Market resolved successfully',
    marketCancelledSuccess: 'Market cancelled, bets refunded',
    friendRequestSent: 'Friend request sent',
    friendRequestAccepted: 'Friend request accepted',
    friendRemoved: 'Friend removed',
    groupCreated: 'Group created',
    categoryCreated: 'Category created',
    isTieredBet: 'Create Tiered Bet',
    tieredOptions: 'Tiered Bet Options',
    titleTemplate: 'Title Template (Use (VALUE) as placeholder)',
    titleTemplatePlaceholder: 'Will Bitcoin be above (VALUE) €?',
    thresholdMode: 'Threshold Input Mode',
    thresholdModeRange: 'Range (Start, End, Step)',
    thresholdModeManual: 'Manual List (Comma-separated)',
    startValue: 'Start Value',
    endValue: 'End Value',
    stepSize: 'Step Size / Interval',
    manualThresholds: 'Thresholds (e.g., 2000, 5000, 10000)',
    manualThresholdsPlaceholder: 'Enter thresholds separated by commas...',
    invalidThresholds: 'Please enter valid threshold values.',
    tieredMarkets: 'Thresholds in this series',
    threshold: 'Threshold',
    currentTier: 'Current Tier',
    minBetAmount: 'Minimum Bet Amount (€)',
    minBetAmountPlaceholder: 'e.g. 5',
    minBetAmountHint: 'The host can set the starting bet amount. Maximum 50 €.',
    maxBetError: 'The bet amount cannot be greater than 50.00 €.',
    staggerDeadlines: 'Stagger deadlines',
    staggerInterval: 'Stagger interval',
    tiersPreview: 'Tiers Preview',
    sharedDeadline: 'Shared deadline',
    hourStagger: '+1 hour per tier',
    dayStagger: '+1 day per tier',
    weekStagger: '+1 week per tier',
    monthStagger: '+1 month per tier',
    yearStagger: '+1 year per tier',
    customStagger: 'Custom adjustment',
  },
  es: {
    // --- Landing (auto-added) ---
    landingTag: 'Pronósticos entre amigos',
    landingHead: 'Predice juntos. Gana juntos.',
    landingSub: 'Scherenmarket es tu plataforma privada de pronósticos. Únete a una organización, crea apuestas de sí/no y compite con amigos.',
    landingReg: 'Registrarse gratis',
    landingLogin: 'Iniciar sesión',
    landingHaveAcc: '¿Ya estás aquí?',
    f1t: 'Organizaciones privadas',
    f1d: 'Tus propios espacios: solo tu grupo ve vuestras apuestas.',
    f2t: 'Crear apuestas',
    f2d: 'Pronósticos de sí/no sobre lo que sea.',
    f3t: 'Liquidar con justicia',
    f3d: 'Dinero ficticio o liquidación real por PayPal: tú decides.',
    landingFooter: 'Mercado de pronósticos para grupos de amigos',
    // --- Organizations & Announcements (auto-added) ---
    orgsTitle: 'Organizaciones',
    orgsSubtitle: 'Únete a una organización para ver y participar en sus apuestas. Puedes estar en varias a la vez.',
    orgsSearch: 'Buscar organización…',
    orgsCreateBtn: 'Crear',
    orgsNoneFound: 'No se encontró ninguna organización.',
    orgMemberBadge: 'Miembro',
    orgRequestedBadge: 'Solicitud enviada',
    orgAcceptedBadge: 'Aceptado',
    orgHostBadge: 'Anfitrión',
    orgMembersWord: 'miembros',
    orgMemberWord: 'miembro',
    orgViewMembers: 'ver',
    orgJoinBtn: 'Unirse',
    orgJoinCode: 'Código de acceso',
    orgEnterCode: 'Introduce un código de acceso.',
    orgRequestJoin: 'Solicitar unirse',
    orgRequestsBtn: 'Solicitudes',
    orgEditBtn: 'Editar',
    orgLeaveBtn: 'Salir',
    orgLeaveTitle: '¿Salir de la organización?',
    orgLeaveDesc: 'Ya no verás sus apuestas y quizá debas unirte de nuevo.',
    orgJoined: 'Te has unido a la organización.',
    orgJoinFailed: 'No se pudo unir.',
    orgRequestSent: 'Solicitud enviada: el anfitrión debe aprobarla.',
    orgRequestFailed: 'La solicitud falló.',
    orgLeft: 'Has salido de la organización.',
    orgLeaveFailed: 'No se pudo salir.',
    orgLoadFailed: 'No se pudieron cargar las organizaciones.',
    orgRequestsLoadFailed: 'No se pudieron cargar las solicitudes.',
    orgApprovedToast: 'Ingreso aprobado.',
    orgRejectedToast: 'Solicitud rechazada.',
    orgActionFailed: 'La acción falló.',
    orgCreateTitle: 'Crear organización',
    orgCreateDesc: 'Serás automáticamente el anfitrión de tu nueva organización.',
    orgNameLabel: 'Nombre',
    orgNameRequired: 'Introduce un nombre.',
    orgDescLabel: 'Descripción',
    orgDescPlaceholder: '¿De qué trata?',
    orgImageLabel: 'URL de imagen',
    orgImageOptional: 'URL de imagen (opcional)',
    orgPolicyLabel: 'Ingreso',
    policyBoth: 'Código o solicitud',
    policyCode: 'Solo con código',
    policyRequest: 'Solo con solicitud',
    orgPaypalBilling: 'Liquidación por PayPal',
    orgPlayMoney: 'Dinero ficticio',
    orgCreated: 'Organización creada.',
    orgCreateFailed: 'No se pudo crear.',
    orgUpdated: 'Organización actualizada.',
    orgSaveFailed: 'No se pudo guardar.',
    orgEditTitle: 'Editar organización',
    orgMembersTitle: 'Miembros',
    orgMembersLoadFailed: 'No se pudieron cargar los miembros.',
    orgRemoveMemberTitle: '¿Eliminar miembro?',
    orgRemoveMemberDesc: 'Esta persona perderá el acceso a esta organización.',
    orgMemberRemoved: 'Miembro eliminado.',
    orgRemoveFailed: 'No se pudo eliminar.',
    orgNoRequests: 'No hay solicitudes pendientes.',
    approveBtn: 'Aprobar',
    rejectBtn: 'Rechazar',
    removeBtn: 'Eliminar',
    orgAcceptedInfo: 'Tu solicitud fue aceptada.',
    orgFinishPaypal: 'Añade tu enlace de PayPal para completar el ingreso.',
    orgFinishJoin: 'Completa tu ingreso.',
    orgJoinWithPaypal: 'Unirse con PayPal',
    orgCompleteJoin: 'Completar ingreso',
    orgPaypalRequired: 'Se requiere enlace de PayPal.',
    announcementClose: 'Cerrar anuncio',
    coins: '€',
    balance: 'Ganancia / Pérdida',
    netProfitLoss: 'Ganancia / Pérdida',
    loading: 'Cargando...',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Guardar',
    saving: 'Guardando...',
    saveChanges: 'Guardar cambios',
    delete: 'Eliminar',
    edit: 'Editar',
    back: 'Atrás',
    viewAll: 'Ver todo',
    search: 'Buscar',
    add: 'Añadir',
    remove: 'Quitar',
    create: 'crear',
    previous: 'Anterior',
    next: 'Siguiente',
    welcomeBack: 'Mercado de Scheren',
    signInToAccount: 'Iniciar sesión',
    email: 'Correo electrónico o nombre de usuario',
    password: 'Contraseña',
    signIn: 'Iniciar sesión',
    signingIn: 'Iniciando sesión...',
    noAccount: 'Don',
    createOne: 'Crea uno',
    createAccount: 'Crear cuenta',
    joinScherenmarket: 'Unirse',
    username: 'Nombre de usuario',
    confirmPassword: 'Confirmar contraseña',
    creatingAccount: 'Creando cuenta...',
    hasAccount: '¿Ya tienes una cuenta?',
    startWithEuro: 'empiezas con',
    canGoNegative: 'Empiezas desde 0 €: ¡apuesta todo lo que quieras!',
    startingCapital: 'Capital inicial: 0 €',
    markets: 'Mercados',
    dashboard: 'Panel de control',
    profile: 'Perfil',
    logout: 'Cerrar sesión',
    language: 'Idioma',
    friends: 'Amigos',
    groups: 'Grupos',
    toggleTheme: 'Alternar tema',
    settlements: 'Pagos y ganancias',
    toPay: 'Para pagar',
    toConfirm: 'Confirmar recibo',
    wonBetsOverview: 'Apuestas Ganadas',
    settlementHistory: 'Historial de pagos',
    noPayoutsToPay: 'Sin deudas de apuestas pendientes. ¡Bien hecho!',
    noPayoutsToConfirm: 'No hay pagos pendientes para confirmar.',
    noWonBetsYet: 'Aún no hay apuestas ganadas.',
    noPayoutHistory: 'Aún no hay historial de pagos.',
    amountToPay: 'Cantidad',
    payee: 'Beneficiario',
    payer: 'Pagador',
    openPaypal: 'Pagar con PayPal',
    confirmReceipt: 'Confirmar recibo',
    receiptConfirmed: 'Recibo confirmado!',
    statusPending: 'Pendiente',
    statusConfirmed: 'Confirmado',
    copied: '¡Copiado!',
    copyInfo: 'Copiar información',
    pendingSettlementsAlert: '¡Tienes acuerdos pendientes! Por favor revisa tus pagos.',
    welcomeBackUser: 'Bienvenido de nuevo,',
    tradingOverview: 'aquí',
    createMarket: 'Crear mercado',
    activeBets: 'Apuestas activas',
    activeWager: 'Apuesta activa',
    totalBets: 'Apuestas totales',
    winRate: 'Tasa de victorias',
    hotMarkets: 'Mercados calientes',
    yourOpenBets: 'Tus apuestas abiertas',
    noOpenBets: 'Sin apuestas abiertas. ¡Encuentre un mercado para comenzar a operar!',
    leaderboard: 'Tabla de clasificación',
    topTraders: 'Principales comerciantes',
    bottomTraders: 'Comerciantes inferiores',
    browseMarkets: 'Mercados',
    browseBet: 'Navega y apuesta por las predicciones.',
    searchMarkets: 'Buscar mercados...',
    all: 'Todos',
    noMarketsFound: 'No se encontraron mercados',
    noMarketsMatch: 'Ningún mercado coincide',
    beFirstToCreate: '¡Sé el primero en crear un mercado!',
    backToMarkets: 'Volver a los mercados',
    marketNotFound: 'Mercado no encontrado',
    by: 'por',
    ends: 'Termina',
    bets: 'apuestas',
    pool: 'piscina',
    timeRemaining: 'Tiempo restante',
    days: 'dias',
    hours: 'Horas',
    mins: 'Minutos',
    secs: 'segundos',
    yes: 'SI',
    no: 'NO',
    betYes: 'APUESTA SI',
    betNo: 'APUESTA NO',
    resolveMarket: 'Resolver el mercado',
    cancelMarket: 'Cancelar mercado',
    cancelMarketConfirm: '¿Realmente cancelar este mercado? Todas las apuestas serán reembolsadas.',
    yourBets: 'Tus apuestas',
    pending: 'pendiente',
    won: 'ganó',
    lost: 'perdido',
    refunded: 'reembolsado',
    potential: 'Potencial',
    ended: 'Terminado',
    visibility: 'Visibilidad',
    visibilityPublic: 'Público',
    visibilityEmailDomain: 'Solo dominio de correo electrónico',
    visibilitySpecificUsers: 'Solo usuarios específicos',
    visibilityGroup: 'Sólo grupo',
    emailDomain: 'Dominio de correo electrónico (por ejemplo, stud.uni-goettingen.de)',
    selectUsers: 'Seleccionar usuarios',
    selectGroup: 'Seleccionar grupo',
    category: 'Categoría',
    categories: 'Categorías',
    noCategory: 'Sin categoría',
    createCategory: 'Crear categoría',
    achievements: 'Logros',
    noAchievements: 'Aún no se han desbloqueado logros.',
    awardedAt: 'Otorgado el',
    categoryName: 'Nombre de categoría',
    tagUsers: 'Etiquetar usuarios',
    taggedUsers: 'Usuarios etiquetados',
    searchUsers: 'Buscar usuarios...',
    userSearch: 'Buscar usuarios',
    userProfile: 'Perfil de usuario',
    memberSince: 'Miembro desde',
    recentBets: 'Apuestas recientes',
    friendsList: 'Lista de amigos',
    friendRequests: 'Solicitudes de amistad',
    addFriend: 'Agregar amigo',
    removeFriend: 'Eliminar amigo',
    acceptRequest: 'Aceptar',
    rejectRequest: 'Rechazar',
    requestSent: 'Solicitud enviada',
    noFriends: 'Aún no hay amigos',
    noPendingRequests: 'No hay solicitudes pendientes',
    editNickname: 'Editar apodo',
    setNickname: 'Establecer apodo',
    nickname: 'Apodo',
    nicknameUpdated: 'Apodo actualizado exitosamente',
    myGroups: 'Mis grupos',
    createGroup: 'Crear grupo',
    groupName: 'Nombre del grupo',
    groupDescription: 'Descripción',
    groupMembers: 'Miembros',
    addMembers: 'Agregar miembros',
    leaveGroup: 'Dejar grupo',
    noGroups: 'Aún no hay grupos',
    copyInviteLink: 'Copiar enlace de invitación',
    copyLinkManually: 'Copiar enlace manualmente:',
    close: 'Cerrar',
    inviteLinkCopied: '¡Enlace de invitación copiado al portapapeles!',
    failedToCopyInviteLink: 'No se pudo copiar el enlace de invitación',
    groupJoined: '¡Unido al grupo exitosamente!',
    joiningGroup: 'Uniéndose al grupo...',
    invalidInviteLink: 'Enlace de invitación no válido',
    alreadyMember: 'Ya eres miembro de este grupo',
    error: 'error',
    backToFriends: 'Volver a Amigos',
    placeBet: 'Realizar apuesta',
    betAmount: 'Monto de la apuesta',
    yourBalance: 'Su ganancia/pérdida',
    placingBet: 'Colocando...',
    betOn: 'Apuesta por',
    selectWinner: 'Seleccione el resultado ganador. Esta acción no se puede deshacer.',
    yesWon: 'SÍ Ganó',
    noWon: 'NO ganado',
    marketResolved: 'Mercado resuelto',
    marketCancelled: 'Mercado cancelado',
    winners: 'Ganadores',
    totalPayout: 'Pago total',
    winnersList: 'Lista de ganadores',
    noWinners: 'No hay ganadores',
    payout: 'Pago',
    createAMarket: 'Crear un mercado',
    createYesNo: 'Cree un mercado de predicción de sí/no para que otros apuesten',
    questionTitle: 'Pregunta / Título',
    questionPlaceholder: '¿Bitcoin alcanzará los 100.000 dólares a finales de 2024?',
    descriptionOptional: 'Descripción (opcional)',
    descriptionPlaceholder: 'Agregue más contexto sobre esta predicción...',
    endDateTime: 'Fecha y hora de finalización',
    pickDateTime: 'Elige fecha y hora',
    marketWillClose: 'El mercado cerrará a esta hora.',
    tipsTitle: 'Consejos para un buen mercado:',
    tip1: 'Haga la pregunta clara e inequívoca.',
    tip2: 'Establezca una fecha de finalización realista',
    tip3: 'Agregar descripción para contexto',
    tip4: 'tu',
    creating: 'Creando...',
    transactions: 'Transacciones',
    betHistory: 'Historial de apuestas',
    noBetsYet: 'Aún no hay apuestas. ¡Empiece a operar!',
    noTransactions: 'Aún no hay transacciones.',
    balanceOverTime: 'Ganancia/pérdida a lo largo del tiempo',
    betResults: 'Resultados de la apuesta',
    statusOpen: 'Abierto',
    statusClosed: 'Cerrado',
    statusResolved: 'Resuelto',
    statusCancelled: 'Cancelado',
    loginFailed: 'Error al iniciar sesión',
    registrationFailed: 'Registro fallido',
    passwordsNoMatch: 'Las contraseñas no coinciden',
    passwordTooShort: 'La contraseña debe tener al menos 6 caracteres.',
    invalidBetAmount: 'Cantidad de apuesta no válida',
    marketCreationFailed: 'No se pudo crear mercado',
    betPlacementFailed: 'No se pudo realizar la apuesta',
    welcomeMessage: '¡Bienvenidos de nuevo!',
    accountCreated: '¡Bienvenidos a Scherenmarket!',
    marketCreated: '¡Mercado creado con éxito!',
    betPlaced: 'Apuesta realizada',
    marketResolvedSuccess: 'Mercado resuelto con éxito',
    marketCancelledSuccess: 'Mercado cancelado, apuestas reembolsadas',
    friendRequestSent: 'Solicitud de amistad enviada',
    friendRequestAccepted: 'Solicitud de amistad aceptada',
    friendRemoved: 'amigo eliminado',
    groupCreated: 'Grupo creado',
    categoryCreated: 'Categoría creada',
    isTieredBet: 'Crear apuesta escalonada',
    tieredOptions: 'Opciones de apuesta escalonada',
    titleTemplate: 'Plantilla de título (use (VALOR) como marcador de posición)',
    titleTemplatePlaceholder: '¿Bitcoin estará por encima de (VALOR) €?',
    thresholdMode: 'Modo de entrada de umbral',
    thresholdModeRange: 'Rango (Inicio, Fin, Paso)',
    thresholdModeManual: 'Lista manual (separada por comas)',
    startValue: 'Valor inicial',
    endValue: 'Valor final',
    stepSize: 'Tamaño del paso/intervalo',
    manualThresholds: 'Umbrales (por ejemplo, 2000, 5000, 10000)',
    manualThresholdsPlaceholder: 'Introduzca umbrales separados por comas...',
    invalidThresholds: 'Introduzca valores de umbral válidos.',
    tieredMarkets: 'Umbrales en esta serie',
    threshold: 'umbral',
    currentTier: 'Nivel actual',
    minBetAmount: 'Importe mínimo de apuesta (€)',
    minBetAmountPlaceholder: 'por ej. 5',
    minBetAmountHint: 'El anfitrión puede establecer el monto de la apuesta inicial. Máximo 50 €.',
    maxBetError: 'El importe de la apuesta no puede ser superior a 50,00 €.',
  },
  fr: {
    // --- Landing (auto-added) ---
    landingTag: 'Pronostics entre amis',
    landingHead: 'Pronostiquez ensemble. Gagnez ensemble.',
    landingSub: 'Scherenmarket est votre plateforme de pronostics privée. Rejoignez une organisation, créez des paris oui/non et affrontez vos amis.',
    landingReg: 'Inscription gratuite',
    landingLogin: 'Se connecter',
    landingHaveAcc: 'Déjà inscrit ?',
    f1t: 'Organisations privées',
    f1d: 'Vos propres espaces – seul votre groupe voit vos paris.',
    f2t: 'Créer des paris',
    f2d: 'Des pronostics oui/non sur tout.',
    f3t: 'Régler équitablement',
    f3d: 'Argent fictif ou règlement PayPal réel – à vous de choisir.',
    landingFooter: 'Marché de pronostics pour groupes d\'amis',
    // --- Organizations & Announcements (auto-added) ---
    orgsTitle: 'Organisations',
    orgsSubtitle: 'Rejoins une organisation pour voir ses paris et y participer. Tu peux en rejoindre plusieurs.',
    orgsSearch: 'Rechercher une organisation…',
    orgsCreateBtn: 'Créer',
    orgsNoneFound: 'Aucune organisation trouvée.',
    orgMemberBadge: 'Membre',
    orgRequestedBadge: 'Demande envoyée',
    orgAcceptedBadge: 'Acceptée',
    orgHostBadge: 'Hôte',
    orgMembersWord: 'membres',
    orgMemberWord: 'membre',
    orgViewMembers: 'voir',
    orgJoinBtn: 'Rejoindre',
    orgJoinCode: 'Code d\'accès',
    orgEnterCode: 'Saisis un code d\'accès.',
    orgRequestJoin: 'Demander à rejoindre',
    orgRequestsBtn: 'Demandes',
    orgEditBtn: 'Modifier',
    orgLeaveBtn: 'Quitter',
    orgLeaveTitle: 'Quitter l\'organisation ?',
    orgLeaveDesc: 'Tu ne verras plus ses paris et devras peut-être la rejoindre à nouveau.',
    orgJoined: 'Organisation rejointe.',
    orgJoinFailed: 'Échec de l\'adhésion.',
    orgRequestSent: 'Demande envoyée – l\'hôte doit l\'approuver.',
    orgRequestFailed: 'Échec de la demande.',
    orgLeft: 'Organisation quittée.',
    orgLeaveFailed: 'Échec du départ.',
    orgLoadFailed: 'Impossible de charger les organisations.',
    orgRequestsLoadFailed: 'Impossible de charger les demandes.',
    orgApprovedToast: 'Adhésion approuvée.',
    orgRejectedToast: 'Demande rejetée.',
    orgActionFailed: 'Échec de l\'action.',
    orgCreateTitle: 'Créer une organisation',
    orgCreateDesc: 'Tu deviendras automatiquement l\'hôte de ta nouvelle organisation.',
    orgNameLabel: 'Nom',
    orgNameRequired: 'Saisis un nom.',
    orgDescLabel: 'Description',
    orgDescPlaceholder: 'De quoi s\'agit-il ?',
    orgImageLabel: 'URL de l\'image',
    orgImageOptional: 'URL de l\'image (facultatif)',
    orgPolicyLabel: 'Adhésion',
    policyBoth: 'Code ou demande',
    policyCode: 'Code uniquement',
    policyRequest: 'Demande uniquement',
    orgPaypalBilling: 'Règlement PayPal',
    orgPlayMoney: 'Argent fictif',
    orgCreated: 'Organisation créée.',
    orgCreateFailed: 'Échec de la création.',
    orgUpdated: 'Organisation mise à jour.',
    orgSaveFailed: 'Échec de l\'enregistrement.',
    orgEditTitle: 'Modifier l\'organisation',
    orgMembersTitle: 'Membres',
    orgMembersLoadFailed: 'Impossible de charger les membres.',
    orgRemoveMemberTitle: 'Retirer le membre ?',
    orgRemoveMemberDesc: 'Cette personne perdra l\'accès à cette organisation.',
    orgMemberRemoved: 'Membre retiré.',
    orgRemoveFailed: 'Échec du retrait.',
    orgNoRequests: 'Aucune demande en attente.',
    approveBtn: 'Approuver',
    rejectBtn: 'Rejeter',
    removeBtn: 'Retirer',
    orgAcceptedInfo: 'Ta demande a été acceptée.',
    orgFinishPaypal: 'Ajoute ton lien PayPal pour finaliser l\'adhésion.',
    orgFinishJoin: 'Finalise ton adhésion.',
    orgJoinWithPaypal: 'Rejoindre avec PayPal',
    orgCompleteJoin: 'Finaliser l\'adhésion',
    orgPaypalRequired: 'Lien PayPal requis.',
    announcementClose: 'Fermer l\'annonce',
    coins: '€',
    balance: 'Bénéfice/Perte',
    netProfitLoss: 'Bénéfice/Perte',
    loading: 'Chargement...',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    save: 'Enregistrer',
    saving: 'Sauvegarde...',
    saveChanges: 'Enregistrer les modifications',
    delete: 'Supprimer',
    edit: 'Modifier',
    back: 'Retour',
    viewAll: 'Voir tout',
    search: 'Rechercher',
    add: 'Ajouter',
    remove: 'Supprimer',
    create: 'Créer',
    previous: 'Précédent',
    next: 'Suivant',
    welcomeBack: 'Marché de Scheren',
    signInToAccount: 'Connectez-vous',
    email: 'E-mail ou nom d\'utilisateur',
    password: 'Mot de passe',
    signIn: 'Connectez-vous',
    signingIn: 'Connexion...',
    noAccount: 'Don',
    createOne: 'Créez-en un',
    createAccount: 'Créer un compte',
    joinScherenmarket: 'Rejoindre',
    username: 'Nom d\'utilisateur',
    confirmPassword: 'Confirmer le mot de passe',
    creatingAccount: 'Création d\'un compte...',
    hasAccount: 'Vous avez déjà un compte ?',
    startWithEuro: 'Tu commences par',
    canGoNegative: 'Vous commencez à 0 € - pariez autant que vous le souhaitez !',
    startingCapital: 'Capital de départ : 0 €',
    markets: 'Marchés',
    dashboard: 'Tableau de bord',
    profile: 'Profil',
    logout: 'Déconnexion',
    language: 'Langue',
    friends: 'Amis',
    groups: 'Groupes',
    toggleTheme: 'Basculer le thème',
    settlements: 'Paiements et gains',
    toPay: 'Payer',
    toConfirm: 'Confirmer la réception',
    wonBetsOverview: 'Paris gagnés',
    settlementHistory: 'Historique des paiements',
    noPayoutsToPay: 'Aucune dette de pari impayée. Bien joué!',
    noPayoutsToConfirm: 'Aucun paiement en attente à confirmer.',
    noWonBetsYet: 'Aucun pari gagné pour l\'instant.',
    noPayoutHistory: 'Aucun historique de paiement pour l\'instant.',
    amountToPay: 'Montant',
    payee: 'Bénéficiaire',
    payer: 'Payeur',
    openPaypal: 'Payer avec PayPal',
    confirmReceipt: 'Confirmer la réception',
    receiptConfirmed: 'Réception confirmée !',
    statusPending: 'En attente',
    statusConfirmed: 'Confirmé',
    copied: 'Copié!',
    copyInfo: 'Copier les informations',
    pendingSettlementsAlert: 'Vous avez des règlements en attente ! Veuillez vérifier vos paiements.',
    welcomeBackUser: 'Bon retour,',
    tradingOverview: 'Ici',
    createMarket: 'Créer un marché',
    activeBets: 'Paris actifs',
    activeWager: 'Pari actif',
    totalBets: 'Paris totaux',
    winRate: 'Taux de victoire',
    hotMarkets: 'Marchés chauds',
    yourOpenBets: 'Vos paris ouverts',
    noOpenBets: 'Pas de paris ouverts. Trouvez un marché pour commencer à trader !',
    leaderboard: 'Classement',
    topTraders: 'Meilleurs commerçants',
    bottomTraders: 'Commerçants inférieurs',
    browseMarkets: 'Marchés',
    browseBet: 'Parcourez et pariez sur les pronostics',
    searchMarkets: 'Rechercher des marchés...',
    all: 'Tout',
    noMarketsFound: 'Aucun marché trouvé',
    noMarketsMatch: 'Aucun marché ne correspond',
    beFirstToCreate: 'Soyez le premier à créer un marché !',
    backToMarkets: 'Retour aux marchés',
    marketNotFound: 'Marché introuvable',
    by: 'par',
    ends: 'Se termine',
    bets: 'paris',
    pool: 'piscine',
    timeRemaining: 'Temps restant',
    days: 'Jours',
    hours: 'Horaires',
    mins: 'Minutes',
    secs: 'Secondes',
    yes: 'OUI',
    no: 'NON',
    betYes: 'PARIER OUI',
    betNo: 'PARI NON',
    resolveMarket: 'Résoudre le marché',
    cancelMarket: 'Annuler le marché',
    cancelMarketConfirm: 'Vraiment annuler ce marché ? Tous les paris seront remboursés.',
    yourBets: 'Vos paris',
    pending: 'en attente',
    won: 'gagné',
    lost: 'perdu',
    refunded: 'remboursé',
    potential: 'Potentiel',
    ended: 'Terminé',
    visibility: 'Visibilité',
    visibilityPublic: 'Publique',
    visibilityEmailDomain: 'Domaine de messagerie uniquement',
    visibilitySpecificUsers: 'Utilisateurs spécifiques uniquement',
    visibilityGroup: 'Groupe uniquement',
    emailDomain: 'Domaine de messagerie (par exemple, stud.uni-goettingen.de)',
    selectUsers: 'Sélectionnez les utilisateurs',
    selectGroup: 'Sélectionner un groupe',
    category: 'Catégorie',
    categories: 'Catégories',
    noCategory: 'Aucune catégorie',
    createCategory: 'Créer une catégorie',
    achievements: 'Réalisations',
    noAchievements: 'Aucun succès débloqué pour l\'instant.',
    awardedAt: 'Attribué le',
    categoryName: 'Nom de la catégorie',
    tagUsers: 'Marquer les utilisateurs',
    taggedUsers: 'Utilisateurs tagués',
    searchUsers: 'Rechercher des utilisateurs...',
    userSearch: 'Rechercher des utilisateurs',
    userProfile: 'Profil utilisateur',
    memberSince: 'Membre depuis',
    recentBets: 'Paris récents',
    friendsList: 'Liste d\'amis',
    friendRequests: 'Demandes d\'amis',
    addFriend: 'Ajouter un ami',
    removeFriend: 'Supprimer un ami',
    acceptRequest: 'Accepter',
    rejectRequest: 'Rejeter',
    requestSent: 'Demande envoyée',
    noFriends: 'Pas encore d\'amis',
    noPendingRequests: 'Aucune demande en attente',
    editNickname: 'Modifier le pseudo',
    setNickname: 'Définir un surnom',
    nickname: 'Surnom',
    nicknameUpdated: 'Pseudonyme mis à jour avec succès',
    myGroups: 'Mes groupes',
    createGroup: 'Créer un groupe',
    groupName: 'Nom du groupe',
    groupDescription: 'Descriptif',
    groupMembers: 'Membres',
    addMembers: 'Ajouter des membres',
    leaveGroup: 'Quitter le groupe',
    noGroups: 'Aucun groupe pour l\'instant',
    copyInviteLink: 'Copier le lien d\'invitation',
    copyLinkManually: 'Copier le lien manuellement :',
    close: 'Fermer',
    inviteLinkCopied: 'Lien d\'invitation copié dans le presse-papier !',
    failedToCopyInviteLink: 'Échec de la copie du lien d\'invitation',
    groupJoined: 'Vous avez rejoint le groupe avec succès !',
    joiningGroup: 'Rejoindre un groupe...',
    invalidInviteLink: 'Lien d\'invitation invalide',
    alreadyMember: 'Vous êtes déjà membre de ce groupe',
    error: 'Erreur',
    backToFriends: 'Retour aux amis',
    placeBet: 'Placer un pari',
    betAmount: 'Montant du pari',
    yourBalance: 'Votre profit/perte',
    placingBet: 'Placer...',
    betOn: 'Parier sur',
    selectWinner: 'Sélectionnez le résultat gagnant. Cette action ne peut pas être annulée.',
    yesWon: 'OUI Gagné',
    noWon: 'NON Gagné',
    marketResolved: 'Marché résolu',
    marketCancelled: 'Marché annulé',
    winners: 'Gagnants',
    totalPayout: 'Paiement total',
    winnersList: 'Liste des gagnants',
    noWinners: 'Aucun gagnant',
    payout: 'Paiement',
    createAMarket: 'Créer un marché',
    createYesNo: 'Créer un marché de prédiction oui/non sur lequel les autres peuvent parier',
    questionTitle: 'Question / Titre',
    questionPlaceholder: 'Bitcoin atteindra-t-il 100 000 $ d’ici fin 2024 ?',
    descriptionOptional: 'Description (Facultatif)',
    descriptionPlaceholder: 'Ajoutez plus de contexte sur cette prédiction...',
    endDateTime: 'Date et heure de fin',
    pickDateTime: 'Choisissez la date et l\'heure',
    marketWillClose: 'Le marché fermera à ce moment-là',
    tipsTitle: 'Conseils pour un bon marché :',
    tip1: 'Rendre la question claire et sans ambiguïté',
    tip2: 'Fixez une date de fin réaliste',
    tip3: 'Ajouter une description pour le contexte',
    tip4: 'Vous',
    creating: 'Création...',
    transactions: 'Opérations',
    betHistory: 'Historique des paris',
    noBetsYet: 'Aucun pari pour l\'instant. Commencez à trader !',
    noTransactions: 'Aucune transaction pour l\'instant.',
    balanceOverTime: 'Bénéfice/perte au fil du temps',
    betResults: 'Résultats des paris',
    statusOpen: 'Ouvert',
    statusClosed: 'Fermé',
    statusResolved: 'Résolu',
    statusCancelled: 'Annulé',
    loginFailed: 'La connexion a échoué',
    registrationFailed: 'L\'inscription a échoué',
    passwordsNoMatch: 'Les mots de passe ne correspondent pas',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
    invalidBetAmount: 'Montant de pari invalide',
    marketCreationFailed: 'Échec de la création du marché',
    betPlacementFailed: 'Échec du placement du pari',
    welcomeMessage: 'Bon retour !',
    accountCreated: 'Bienvenue sur le marché de Scheren !',
    marketCreated: 'Marché créé avec succès !',
    betPlaced: 'Pari placé',
    marketResolvedSuccess: 'Marché résolu avec succès',
    marketCancelledSuccess: 'Marché annulé, paris remboursés',
    friendRequestSent: 'Demande d\'ami envoyée',
    friendRequestAccepted: 'Demande d\'ami acceptée',
    friendRemoved: 'Ami supprimé',
    groupCreated: 'Groupe créé',
    categoryCreated: 'Catégorie créée',
    isTieredBet: 'Créer un pari à plusieurs niveaux',
    tieredOptions: 'Options de pari à plusieurs niveaux',
    titleTemplate: 'Modèle de titre (utiliser (VALUE) comme espace réservé)',
    titleTemplatePlaceholder: 'Le Bitcoin sera-t-il supérieur à (VALEUR) € ?',
    thresholdMode: 'Mode d\'entrée de seuil',
    thresholdModeRange: 'Plage (début, fin, étape)',
    thresholdModeManual: 'Liste manuelle (séparés par des virgules)',
    startValue: 'Valeur de départ',
    endValue: 'Valeur finale',
    stepSize: 'Taille du pas/intervalle',
    manualThresholds: 'Seuils (par exemple, 2 000, 5 000, 10 000)',
    manualThresholdsPlaceholder: 'Entrez les seuils séparés par des virgules...',
    invalidThresholds: 'Veuillez saisir des valeurs de seuil valides.',
    tieredMarkets: 'Seuils dans cette série',
    threshold: 'Seuil',
    currentTier: 'Niveau actuel',
    minBetAmount: 'Montant minimum de mise (€)',
    minBetAmountPlaceholder: 'par ex. 5',
    minBetAmountHint: 'L\'hôte peut définir le montant de la mise de départ. Maximum 50 €.',
    maxBetError: 'Le montant du pari ne peut pas être supérieur à 50,00 €.',
  },
  it: {
    // --- Landing (auto-added) ---
    landingTag: 'Pronostici tra amici',
    landingHead: 'Pronostica insieme. Vinci insieme.',
    landingSub: 'Scherenmarket è la tua piattaforma di pronostici privata. Unisciti a un\'organizzazione, crea scommesse sì/no e sfida gli amici.',
    landingReg: 'Registrati gratis',
    landingLogin: 'Accedi',
    landingHaveAcc: 'Già iscritto?',
    f1t: 'Organizzazioni private',
    f1d: 'Spazi tutti tuoi – solo il tuo gruppo vede le vostre scommesse.',
    f2t: 'Crea scommesse',
    f2d: 'Pronostici sì/no su qualsiasi cosa.',
    f3t: 'Regola in modo equo',
    f3d: 'Denaro virtuale o pagamento PayPal reale – decidi tu.',
    landingFooter: 'Mercato di pronostici per gruppi di amici',
    // --- Organizations & Announcements (auto-added) ---
    orgsTitle: 'Organizzazioni',
    orgsSubtitle: 'Unisciti a un\'organizzazione per vedere e partecipare alle sue scommesse. Puoi farne parte di più di una.',
    orgsSearch: 'Cerca organizzazione…',
    orgsCreateBtn: 'Crea',
    orgsNoneFound: 'Nessuna organizzazione trovata.',
    orgMemberBadge: 'Membro',
    orgRequestedBadge: 'Richiesta inviata',
    orgAcceptedBadge: 'Accettata',
    orgHostBadge: 'Host',
    orgMembersWord: 'membri',
    orgMemberWord: 'membro',
    orgViewMembers: 'vedi',
    orgJoinBtn: 'Unisciti',
    orgJoinCode: 'Codice di accesso',
    orgEnterCode: 'Inserisci un codice di accesso.',
    orgRequestJoin: 'Richiedi di unirti',
    orgRequestsBtn: 'Richieste',
    orgEditBtn: 'Modifica',
    orgLeaveBtn: 'Esci',
    orgLeaveTitle: 'Uscire dall\'organizzazione?',
    orgLeaveDesc: 'Non vedrai più le sue scommesse e dovrai eventualmente rientrare.',
    orgJoined: 'Ti sei unito all\'organizzazione.',
    orgJoinFailed: 'Iscrizione non riuscita.',
    orgRequestSent: 'Richiesta inviata: l\'host deve approvarla.',
    orgRequestFailed: 'Richiesta non riuscita.',
    orgLeft: 'Hai lasciato l\'organizzazione.',
    orgLeaveFailed: 'Uscita non riuscita.',
    orgLoadFailed: 'Impossibile caricare le organizzazioni.',
    orgRequestsLoadFailed: 'Impossibile caricare le richieste.',
    orgApprovedToast: 'Ingresso approvato.',
    orgRejectedToast: 'Richiesta rifiutata.',
    orgActionFailed: 'Azione non riuscita.',
    orgCreateTitle: 'Crea organizzazione',
    orgCreateDesc: 'Diventerai automaticamente l\'host della tua nuova organizzazione.',
    orgNameLabel: 'Nome',
    orgNameRequired: 'Inserisci un nome.',
    orgDescLabel: 'Descrizione',
    orgDescPlaceholder: 'Di cosa si tratta?',
    orgImageLabel: 'URL immagine',
    orgImageOptional: 'URL immagine (facoltativo)',
    orgPolicyLabel: 'Ingresso',
    policyBoth: 'Codice o richiesta',
    policyCode: 'Solo codice',
    policyRequest: 'Solo richiesta',
    orgPaypalBilling: 'Pagamenti PayPal',
    orgPlayMoney: 'Denaro virtuale',
    orgCreated: 'Organizzazione creata.',
    orgCreateFailed: 'Creazione non riuscita.',
    orgUpdated: 'Organizzazione aggiornata.',
    orgSaveFailed: 'Salvataggio non riuscito.',
    orgEditTitle: 'Modifica organizzazione',
    orgMembersTitle: 'Membri',
    orgMembersLoadFailed: 'Impossibile caricare i membri.',
    orgRemoveMemberTitle: 'Rimuovere il membro?',
    orgRemoveMemberDesc: 'Questa persona perderà l\'accesso all\'organizzazione.',
    orgMemberRemoved: 'Membro rimosso.',
    orgRemoveFailed: 'Rimozione non riuscita.',
    orgNoRequests: 'Nessuna richiesta in sospeso.',
    approveBtn: 'Approva',
    rejectBtn: 'Rifiuta',
    removeBtn: 'Rimuovi',
    orgAcceptedInfo: 'La tua richiesta è stata accettata.',
    orgFinishPaypal: 'Aggiungi il tuo link PayPal per completare l\'ingresso.',
    orgFinishJoin: 'Completa l\'ingresso.',
    orgJoinWithPaypal: 'Unisciti con PayPal',
    orgCompleteJoin: 'Completa ingresso',
    orgPaypalRequired: 'Link PayPal richiesto.',
    announcementClose: 'Chiudi annuncio',
    coins: '€',
    balance: 'Profitti/perdite',
    netProfitLoss: 'Profitti/perdite',
    loading: 'Caricamento...',
    cancel: 'Annulla',
    confirm: 'Conferma',
    save: 'Salva',
    saving: 'Salvataggio...',
    saveChanges: 'Salva modifiche',
    delete: 'Elimina',
    edit: 'Modifica',
    back: 'Indietro',
    viewAll: 'Visualizza tutto',
    search: 'Cerca',
    add: 'Aggiungi',
    remove: 'Rimuovi',
    create: 'Crea',
    previous: 'Precedente',
    next: 'Avanti',
    welcomeBack: 'Scherenmarket',
    signInToAccount: 'Accedi',
    email: 'E-mail o nome utente',
    password: 'Parola d\'ordine',
    signIn: 'Accedi',
    signingIn: 'Accesso...',
    noAccount: 'Don',
    createOne: 'Creane uno',
    createAccount: 'Crea account',
    joinScherenmarket: 'Partecipa',
    username: 'Nome utente',
    confirmPassword: 'Conferma password',
    creatingAccount: 'Creazione dell\'account...',
    hasAccount: 'Hai già un account?',
    startWithEuro: 'Inizi con',
    canGoNegative: 'Inizi da 0 €: scommetti quanto vuoi!',
    startingCapital: 'Capitale Iniziale: 0 €',
    markets: 'Mercati',
    dashboard: 'Cruscotto',
    profile: 'Profilo',
    logout: 'Esci',
    language: 'Lingua',
    friends: 'Amici',
    groups: 'Gruppi',
    toggleTheme: 'Attiva/disattiva tema',
    settlements: 'Pagamenti e vincite',
    toPay: 'Pagare',
    toConfirm: 'Conferma ricevuta',
    wonBetsOverview: 'Scommesse vinte',
    settlementHistory: 'Cronologia dei pagamenti',
    noPayoutsToPay: 'Nessun debito di scommessa in sospeso. Ben fatto!',
    noPayoutsToConfirm: 'Nessun pagamento in sospeso da confermare.',
    noWonBetsYet: 'Nessuna scommessa vinta ancora.',
    noPayoutHistory: 'Nessuna cronologia dei pagamenti ancora.',
    amountToPay: 'Importo',
    payee: 'Beneficiario',
    payer: 'Pagatore',
    openPaypal: 'Paga con PayPal',
    confirmReceipt: 'Conferma ricevuta',
    receiptConfirmed: 'Ricevuta confermata!',
    statusPending: 'In sospeso',
    statusConfirmed: 'Confermato',
    copied: 'Copiato!',
    copyInfo: 'Copia informazioni',
    pendingSettlementsAlert: 'Hai degli accordi in sospeso! Controlla i tuoi pagamenti.',
    welcomeBackUser: 'Bentornato,',
    tradingOverview: 'Ecco',
    createMarket: 'Crea mercato',
    activeBets: 'Scommesse attive',
    activeWager: 'Scommessa attiva',
    totalBets: 'Scommesse totali',
    winRate: 'Tasso di vincita',
    hotMarkets: 'Mercati caldi',
    yourOpenBets: 'Le tue scommesse aperte',
    noOpenBets: 'Nessuna scommessa aperta. Trova un mercato per iniziare a fare trading!',
    leaderboard: 'Classifica',
    topTraders: 'I migliori trader',
    bottomTraders: 'Commercianti di fondo',
    browseMarkets: 'Mercati',
    browseBet: 'Naviga e scommetti sui pronostici',
    searchMarkets: 'Cerca mercati...',
    all: 'Tutto',
    noMarketsFound: 'Nessun mercato trovato',
    noMarketsMatch: 'Nessun mercato corrisponde',
    beFirstToCreate: 'Sii il primo a creare un mercato!',
    backToMarkets: 'Torniamo ai mercati',
    marketNotFound: 'Mercato non trovato',
    by: 'di',
    ends: 'Finisce',
    bets: 'scommesse',
    pool: 'piscina',
    timeRemaining: 'Tempo rimanente',
    days: 'Giorni',
    hours: 'Ore',
    mins: 'Min',
    secs: 'Sez',
    yes: 'SÌ',
    no: 'NO',
    betYes: 'SCOMMESSA SÌ',
    betNo: 'SCOMMESSA NO',
    resolveMarket: 'Risolvere il mercato',
    cancelMarket: 'Annulla mercato',
    cancelMarketConfirm: 'Cancellare davvero questo mercato? Tutte le scommesse verranno rimborsate.',
    yourBets: 'Le tue scommesse',
    pending: 'in sospeso',
    won: 'vinto',
    lost: 'perso',
    refunded: 'rimborsato',
    potential: 'Potenziale',
    ended: 'Finito',
    visibility: 'Visibilità',
    visibilityPublic: 'Pubblico',
    visibilityEmailDomain: 'Solo dominio di posta elettronica',
    visibilitySpecificUsers: 'Solo utenti specifici',
    visibilityGroup: 'Solo gruppo',
    emailDomain: 'Dominio e-mail (ad esempio stud.uni-goettingen.de)',
    selectUsers: 'Seleziona gli utenti',
    selectGroup: 'Seleziona gruppo',
    category: 'Categoria',
    categories: 'Categorie',
    noCategory: 'Nessuna categoria',
    createCategory: 'Crea categoria',
    achievements: 'Risultati',
    noAchievements: 'Nessun obiettivo ancora sbloccato.',
    awardedAt: 'Premiato il',
    categoryName: 'Nome della categoria',
    tagUsers: 'Tagga gli utenti',
    taggedUsers: 'Utenti taggati',
    searchUsers: 'Cerca utenti...',
    userSearch: 'Cerca utenti',
    userProfile: 'Profilo utente',
    memberSince: 'Membro da allora',
    recentBets: 'Scommesse recenti',
    friendsList: 'Elenco amici',
    friendRequests: 'Richieste di amicizia',
    addFriend: 'Aggiungi amico',
    removeFriend: 'Rimuovi amico',
    acceptRequest: 'Accetta',
    rejectRequest: 'Rifiuta',
    requestSent: 'Richiesta inviata',
    noFriends: 'Nessun amico ancora',
    noPendingRequests: 'Nessuna richiesta in sospeso',
    editNickname: 'Modifica soprannome',
    setNickname: 'Imposta soprannome',
    nickname: 'Soprannome',
    nicknameUpdated: 'Nickname aggiornato con successo',
    myGroups: 'I miei gruppi',
    createGroup: 'Crea gruppo',
    groupName: 'Nome del gruppo',
    groupDescription: 'Descrizione',
    groupMembers: 'Membri',
    addMembers: 'Aggiungi membri',
    leaveGroup: 'Lascia il gruppo',
    noGroups: 'Nessun gruppo ancora',
    copyInviteLink: 'Copia il link di invito',
    copyLinkManually: 'Copia il collegamento manualmente:',
    close: 'Chiudi',
    inviteLinkCopied: 'Link di invito copiato negli appunti!',
    failedToCopyInviteLink: 'Impossibile copiare il collegamento di invito',
    groupJoined: 'Iscrizione al gruppo riuscita!',
    joiningGroup: 'Iscrizione al gruppo...',
    invalidInviteLink: 'Link di invito non valido',
    alreadyMember: 'Sei già membro di questo gruppo',
    error: 'Errore',
    backToFriends: 'Torniamo ad Amici',
    placeBet: 'Piazza la scommessa',
    betAmount: 'Importo della scommessa',
    yourBalance: 'Il tuo profitto/perdita',
    placingBet: 'Posizionamento...',
    betOn: 'Scommetti su',
    selectWinner: 'Seleziona il risultato vincente. Questa azione non può essere annullata.',
    yesWon: 'SI, vinto',
    noWon: 'NO vinto',
    marketResolved: 'Mercato risolto',
    marketCancelled: 'Mercato annullato',
    winners: 'Vincitori',
    totalPayout: 'Pagamento totale',
    winnersList: 'Elenco dei vincitori',
    noWinners: 'Nessun vincitore',
    payout: 'Pagamento',
    createAMarket: 'Creare un mercato',
    createYesNo: 'Crea un mercato di previsione sì/no su cui gli altri possono scommettere',
    questionTitle: 'Domanda/Titolo',
    questionPlaceholder: 'Bitcoin raggiungerà i 100.000 dollari entro la fine del 2024?',
    descriptionOptional: 'Descrizione (facoltativa)',
    descriptionPlaceholder: 'Aggiungi più contesto su questa previsione...',
    endDateTime: 'Data e ora di fine',
    pickDateTime: 'Scegli data e ora',
    marketWillClose: 'Il mercato chiuderà in questo momento',
    tipsTitle: 'Suggerimenti per un buon mercato:',
    tip1: 'Rendi la domanda chiara e inequivocabile',
    tip2: 'Stabilisci una data di fine realistica',
    tip3: 'Aggiungi una descrizione per il contesto',
    tip4: 'Tu',
    creating: 'Creazione...',
    transactions: 'Transazioni',
    betHistory: 'Cronologia delle scommesse',
    noBetsYet: 'Nessuna scommessa ancora. Inizia a fare trading!',
    noTransactions: 'Nessuna transazione ancora.',
    balanceOverTime: 'Profitti/perdite nel tempo',
    betResults: 'Risultati delle scommesse',
    statusOpen: 'Aperto',
    statusClosed: 'Chiuso',
    statusResolved: 'Risolto',
    statusCancelled: 'Annullato',
    loginFailed: 'Accesso non riuscito',
    registrationFailed: 'La registrazione non è riuscita',
    passwordsNoMatch: 'Le password non corrispondono',
    passwordTooShort: 'La password deve contenere almeno 6 caratteri',
    invalidBetAmount: 'Importo della scommessa non valido',
    marketCreationFailed: 'Impossibile creare il mercato',
    betPlacementFailed: 'Impossibile piazzare la scommessa',
    welcomeMessage: 'Bentornato!',
    accountCreated: 'Benvenuti allo Scherenmarket!',
    marketCreated: 'Mercato creato con successo!',
    betPlaced: 'Scommessa piazzata',
    marketResolvedSuccess: 'Il mercato si è risolto con successo',
    marketCancelledSuccess: 'Mercato annullato, scommesse rimborsate',
    friendRequestSent: 'Richiesta di amicizia inviata',
    friendRequestAccepted: 'Richiesta di amicizia accettata',
    friendRemoved: 'Amico rimosso',
    groupCreated: 'Gruppo creato',
    categoryCreated: 'Categoria creata',
    isTieredBet: 'Crea scommessa a più livelli',
    tieredOptions: 'Opzioni di scommessa a più livelli',
    titleTemplate: 'Modello titolo (utilizza (VALUE) come segnaposto)',
    titleTemplatePlaceholder: 'Il Bitcoin sarà superiore a (VALUE) €?',
    thresholdMode: 'Modalità di ingresso soglia',
    thresholdModeRange: 'Intervallo (Inizio, Fine, Passo)',
    thresholdModeManual: 'Elenco manuali (separati da virgole)',
    startValue: 'Valore iniziale',
    endValue: 'Valore finale',
    stepSize: 'Dimensione passo/intervallo',
    manualThresholds: 'Soglie (ad esempio, 2000, 5000, 10000)',
    manualThresholdsPlaceholder: 'Inserisci le soglie separate da virgole...',
    invalidThresholds: 'Inserisci valori di soglia validi.',
    tieredMarkets: 'Soglie in questa serie',
    threshold: 'Soglia',
    currentTier: 'Livello attuale',
    minBetAmount: 'Importo minimo della scommessa (€)',
    minBetAmountPlaceholder: 'ad es. 5',
    minBetAmountHint: 'L\'host può impostare l\'importo della scommessa iniziale. Massimo 50€.',
    maxBetError: 'L\'importo della scommessa non può essere superiore a 50,00 €.',
  },
  pt: {
    // --- Landing (auto-added) ---
    landingTag: 'Previsões entre amigos',
    landingHead: 'Prevejam juntos. Ganhem juntos.',
    landingSub: 'O Scherenmarket é a tua plataforma de previsões privada. Entra numa organização, cria apostas sim/não e compete com amigos.',
    landingReg: 'Registar grátis',
    landingLogin: 'Entrar',
    landingHaveAcc: 'Já tens conta?',
    f1t: 'Organizações privadas',
    f1d: 'Os teus próprios espaços – só o teu grupo vê as apostas.',
    f2t: 'Criar apostas',
    f2d: 'Previsões sim/não sobre tudo.',
    f3t: 'Acertar contas de forma justa',
    f3d: 'Dinheiro fictício ou liquidação real por PayPal – tu decides.',
    landingFooter: 'Mercado de previsões para grupos de amigos',
    // --- Organizations & Announcements (auto-added) ---
    orgsTitle: 'Organizações',
    orgsSubtitle: 'Entra numa organização para ver e participar nas suas apostas. Podes estar em várias ao mesmo tempo.',
    orgsSearch: 'Procurar organização…',
    orgsCreateBtn: 'Criar',
    orgsNoneFound: 'Nenhuma organização encontrada.',
    orgMemberBadge: 'Membro',
    orgRequestedBadge: 'Pedido enviado',
    orgAcceptedBadge: 'Aceite',
    orgHostBadge: 'Anfitrião',
    orgMembersWord: 'membros',
    orgMemberWord: 'membro',
    orgViewMembers: 'ver',
    orgJoinBtn: 'Entrar',
    orgJoinCode: 'Código de acesso',
    orgEnterCode: 'Introduz um código de acesso.',
    orgRequestJoin: 'Pedir para entrar',
    orgRequestsBtn: 'Pedidos',
    orgEditBtn: 'Editar',
    orgLeaveBtn: 'Sair',
    orgLeaveTitle: 'Sair da organização?',
    orgLeaveDesc: 'Deixarás de ver as suas apostas e talvez precises de entrar novamente.',
    orgJoined: 'Entraste na organização.',
    orgJoinFailed: 'Falha ao entrar.',
    orgRequestSent: 'Pedido enviado – o anfitrião tem de o aprovar.',
    orgRequestFailed: 'O pedido falhou.',
    orgLeft: 'Saíste da organização.',
    orgLeaveFailed: 'Falha ao sair.',
    orgLoadFailed: 'Não foi possível carregar as organizações.',
    orgRequestsLoadFailed: 'Não foi possível carregar os pedidos.',
    orgApprovedToast: 'Entrada aprovada.',
    orgRejectedToast: 'Pedido rejeitado.',
    orgActionFailed: 'A ação falhou.',
    orgCreateTitle: 'Criar organização',
    orgCreateDesc: 'Serás automaticamente o anfitrião da tua nova organização.',
    orgNameLabel: 'Nome',
    orgNameRequired: 'Introduz um nome.',
    orgDescLabel: 'Descrição',
    orgDescPlaceholder: 'De que se trata?',
    orgImageLabel: 'URL da imagem',
    orgImageOptional: 'URL da imagem (opcional)',
    orgPolicyLabel: 'Entrada',
    policyBoth: 'Código ou pedido',
    policyCode: 'Apenas código',
    policyRequest: 'Apenas pedido',
    orgPaypalBilling: 'Liquidação PayPal',
    orgPlayMoney: 'Dinheiro fictício',
    orgCreated: 'Organização criada.',
    orgCreateFailed: 'Falha ao criar.',
    orgUpdated: 'Organização atualizada.',
    orgSaveFailed: 'Falha ao guardar.',
    orgEditTitle: 'Editar organização',
    orgMembersTitle: 'Membros',
    orgMembersLoadFailed: 'Não foi possível carregar os membros.',
    orgRemoveMemberTitle: 'Remover membro?',
    orgRemoveMemberDesc: 'Esta pessoa perderá o acesso a esta organização.',
    orgMemberRemoved: 'Membro removido.',
    orgRemoveFailed: 'Falha ao remover.',
    orgNoRequests: 'Sem pedidos pendentes.',
    approveBtn: 'Aprovar',
    rejectBtn: 'Rejeitar',
    removeBtn: 'Remover',
    orgAcceptedInfo: 'O teu pedido foi aceite.',
    orgFinishPaypal: 'Adiciona o teu link PayPal para concluir a entrada.',
    orgFinishJoin: 'Conclui a tua entrada.',
    orgJoinWithPaypal: 'Entrar com PayPal',
    orgCompleteJoin: 'Concluir entrada',
    orgPaypalRequired: 'Link PayPal necessário.',
    announcementClose: 'Fechar anúncio',
    coins: '€',
    balance: 'Lucro / Perda',
    netProfitLoss: 'Lucro / Perda',
    loading: 'Carregando...',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Salvar',
    saving: 'Salvando...',
    saveChanges: 'Salvar alterações',
    delete: 'Excluir',
    edit: 'Editar',
    back: 'Voltar',
    viewAll: 'Ver tudo',
    search: 'Pesquisar',
    add: 'Adicionar',
    remove: 'Remover',
    create: 'Criar',
    previous: 'Anterior',
    next: 'Próximo',
    welcomeBack: 'Mercado Scheren',
    signInToAccount: 'Faça login',
    email: 'E-mail ou nome de usuário',
    password: 'Senha',
    signIn: 'Entrar',
    signingIn: 'Fazendo login...',
    noAccount: 'Don',
    createOne: 'Crie um',
    createAccount: 'Criar conta',
    joinScherenmarket: 'Junte-se',
    username: 'Nome de usuário',
    confirmPassword: 'Confirmar senha',
    creatingAccount: 'Criando conta...',
    hasAccount: 'Já tem uma conta?',
    startWithEuro: 'Você começa com',
    canGoNegative: 'Você começa em 0 € - aposte o quanto quiser!',
    startingCapital: 'Capital inicial: 0 €',
    markets: 'Mercados',
    dashboard: 'Painel',
    profile: 'Perfil',
    logout: 'Sair',
    language: 'Idioma',
    friends: 'Amigos',
    groups: 'Grupos',
    toggleTheme: 'Alternar tema',
    settlements: 'Pagamentos e ganhos',
    toPay: 'Pagar',
    toConfirm: 'Confirmar recebimento',
    wonBetsOverview: 'Apostas ganhas',
    settlementHistory: 'Histórico de pagamentos',
    noPayoutsToPay: 'Nenhuma dívida de aposta pendente. Bom trabalho!',
    noPayoutsToConfirm: 'Nenhum pagamento pendente para confirmar.',
    noWonBetsYet: 'Nenhuma aposta ganha ainda.',
    noPayoutHistory: 'Ainda não há histórico de pagamentos.',
    amountToPay: 'Quantidade',
    payee: 'Beneficiário',
    payer: 'Pagador',
    openPaypal: 'Pague com PayPal',
    confirmReceipt: 'Confirmar recebimento',
    receiptConfirmed: 'Recebimento confirmado!',
    statusPending: 'Pendente',
    statusConfirmed: 'Confirmado',
    copied: 'Copiado!',
    copyInfo: 'Copiar informações',
    pendingSettlementsAlert: 'Você tem liquidações pendentes! Por favor, verifique seus pagamentos.',
    welcomeBackUser: 'Bem-vindo de volta,',
    tradingOverview: 'Aqui',
    createMarket: 'Criar mercado',
    activeBets: 'Apostas Ativas',
    activeWager: 'Aposta Ativa',
    totalBets: 'Apostas totais',
    winRate: 'Taxa de vitórias',
    hotMarkets: 'Mercados Quentes',
    yourOpenBets: 'Suas apostas abertas',
    noOpenBets: 'Não há apostas abertas. Encontre um mercado para começar a negociar!',
    leaderboard: 'Tabela de classificação',
    topTraders: 'Principais comerciantes',
    bottomTraders: 'Traders inferiores',
    browseMarkets: 'Mercados',
    browseBet: 'Navegue e aposte em previsões',
    searchMarkets: 'Pesquisar mercados...',
    all: 'Todos',
    noMarketsFound: 'Nenhum mercado encontrado',
    noMarketsMatch: 'Nenhum mercado corresponde',
    beFirstToCreate: 'Seja o primeiro a criar um mercado!',
    backToMarkets: 'De volta aos mercados',
    marketNotFound: 'Mercado não encontrado',
    by: 'por',
    ends: 'Termina',
    bets: 'apostas',
    pool: 'piscina',
    timeRemaining: 'Tempo restante',
    days: 'Dias',
    hours: 'Horas',
    mins: 'Minutos',
    secs: 'Segundos',
    yes: 'SIM',
    no: 'NÃO',
    betYes: 'APOSTE SIM',
    betNo: 'APOSTE NÃO',
    resolveMarket: 'Resolver Mercado',
    cancelMarket: 'Cancelar mercado',
    cancelMarketConfirm: 'Realmente cancelar este mercado? Todas as apostas serão reembolsadas.',
    yourBets: 'Suas apostas',
    pending: 'pendente',
    won: 'ganhou',
    lost: 'perdido',
    refunded: 'reembolsado',
    potential: 'Potencial',
    ended: 'Terminou',
    visibility: 'Visibilidade',
    visibilityPublic: 'Público',
    visibilityEmailDomain: 'Somente domínio de e-mail',
    visibilitySpecificUsers: 'Somente usuários específicos',
    visibilityGroup: 'Somente grupo',
    emailDomain: 'Domínio de e-mail (por exemplo, stud.uni-goettingen.de)',
    selectUsers: 'Selecione usuários',
    selectGroup: 'Selecione o grupo',
    category: 'Categoria',
    categories: 'Categorias',
    noCategory: 'Nenhuma categoria',
    createCategory: 'Criar categoria',
    achievements: 'Conquistas',
    noAchievements: 'Nenhuma conquista desbloqueada ainda.',
    awardedAt: 'Concedido em',
    categoryName: 'Nome da categoria',
    tagUsers: 'Marcar usuários',
    taggedUsers: 'Usuários marcados',
    searchUsers: 'Pesquisar usuários...',
    userSearch: 'Pesquisar usuários',
    userProfile: 'Perfil de usuário',
    memberSince: 'Membro desde',
    recentBets: 'Apostas recentes',
    friendsList: 'Lista de amigos',
    friendRequests: 'Pedidos de amizade',
    addFriend: 'Adicionar amigo',
    removeFriend: 'Remover amigo',
    acceptRequest: 'Aceitar',
    rejectRequest: 'Rejeitar',
    requestSent: 'Solicitação enviada',
    noFriends: 'Ainda não há amigos',
    noPendingRequests: 'Nenhuma solicitação pendente',
    editNickname: 'Editar apelido',
    setNickname: 'Definir apelido',
    nickname: 'Apelido',
    nicknameUpdated: 'Apelido atualizado com sucesso',
    myGroups: 'Meus grupos',
    createGroup: 'Criar grupo',
    groupName: 'Nome do grupo',
    groupDescription: 'Descrição',
    groupMembers: 'Membros',
    addMembers: 'Adicionar membros',
    leaveGroup: 'Sair do grupo',
    noGroups: 'Nenhum grupo ainda',
    copyInviteLink: 'Copiar link de convite',
    copyLinkManually: 'Copiar link manualmente:',
    close: 'Fechar',
    inviteLinkCopied: 'Link de convite copiado para a área de transferência!',
    failedToCopyInviteLink: 'Falha ao copiar o link do convite',
    groupJoined: 'Entrou no grupo com sucesso!',
    joiningGroup: 'Entrando no grupo...',
    invalidInviteLink: 'Link de convite inválido',
    alreadyMember: 'Você já é membro deste grupo',
    error: 'Erro',
    backToFriends: 'Voltar para amigos',
    placeBet: 'Fazer aposta',
    betAmount: 'Valor da aposta',
    yourBalance: 'Seu lucro/perda',
    placingBet: 'Colocando...',
    betOn: 'Aposte em',
    selectWinner: 'Selecione o resultado vencedor. Esta ação não pode ser desfeita.',
    yesWon: 'SIM ganhou',
    noWon: 'NÃO ganhou',
    marketResolved: 'Mercado resolvido',
    marketCancelled: 'Mercado cancelado',
    winners: 'Vencedores',
    totalPayout: 'Pagamento total',
    winnersList: 'Lista de vencedores',
    noWinners: 'Nenhum vencedor',
    payout: 'Pagamento',
    createAMarket: 'Crie um mercado',
    createYesNo: 'Crie um mercado de previsão sim/não para outros apostarem',
    questionTitle: 'Pergunta/Título',
    questionPlaceholder: 'O Bitcoin alcançará US$ 100 mil até o final de 2024?',
    descriptionOptional: 'Descrição (opcional)',
    descriptionPlaceholder: 'Adicione mais contexto sobre esta previsão...',
    endDateTime: 'Data e hora de término',
    pickDateTime: 'Escolha data e hora',
    marketWillClose: 'O mercado fechará neste momento',
    tipsTitle: 'Dicas para um bom mercado:',
    tip1: 'Deixe a pergunta clara e inequívoca',
    tip2: 'Defina uma data de término realista',
    tip3: 'Adicione uma descrição para contexto',
    tip4: 'Você',
    creating: 'Criando...',
    transactions: 'Transações',
    betHistory: 'Histórico de apostas',
    noBetsYet: 'Nenhuma aposta ainda. Comece a negociar!',
    noTransactions: 'Nenhuma transação ainda.',
    balanceOverTime: 'Lucro/perda ao longo do tempo',
    betResults: 'Resultados das apostas',
    statusOpen: 'Abrir',
    statusClosed: 'Fechado',
    statusResolved: 'Resolvido',
    statusCancelled: 'Cancelado',
    loginFailed: 'Falha no login',
    registrationFailed: 'Falha no registro',
    passwordsNoMatch: 'As senhas não coincidem',
    passwordTooShort: 'A senha deve ter pelo menos 6 caracteres',
    invalidBetAmount: 'Valor de aposta inválido',
    marketCreationFailed: 'Falha ao criar mercado',
    betPlacementFailed: 'Falha ao fazer aposta',
    welcomeMessage: 'Bem-vindo de volta!',
    accountCreated: 'Bem-vindo ao Scherenmarket!',
    marketCreated: 'Mercado criado com sucesso!',
    betPlaced: 'Aposta feita',
    marketResolvedSuccess: 'Mercado resolvido com sucesso',
    marketCancelledSuccess: 'Mercado cancelado, apostas reembolsadas',
    friendRequestSent: 'Pedido de amizade enviado',
    friendRequestAccepted: 'Pedido de amizade aceito',
    friendRemoved: 'Amigo removido',
    groupCreated: 'Grupo criado',
    categoryCreated: 'Categoria criada',
    isTieredBet: 'Criar aposta em níveis',
    tieredOptions: 'Opções de apostas em níveis',
    titleTemplate: 'Modelo de título (use (VALUE) como espaço reservado)',
    titleTemplatePlaceholder: 'O Bitcoin estará acima de (VALOR) €?',
    thresholdMode: 'Modo de entrada de limite',
    thresholdModeRange: 'Intervalo (início, fim, etapa)',
    thresholdModeManual: 'Lista manual (separada por vírgula)',
    startValue: 'Valor inicial',
    endValue: 'Valor final',
    stepSize: 'Tamanho/intervalo do passo',
    manualThresholds: 'Limites (por exemplo, 2.000, 5.000, 10.000)',
    manualThresholdsPlaceholder: 'Insira limites separados por vírgulas...',
    invalidThresholds: 'Insira valores limite válidos.',
    tieredMarkets: 'Limites nesta série',
    threshold: 'Limite',
    currentTier: 'Nível atual',
    minBetAmount: 'Valor Mínimo da Aposta (€)',
    minBetAmountPlaceholder: 'por exemplo 5',
    minBetAmountHint: 'O anfitrião pode definir o valor da aposta inicial. Máximo 50€.',
    maxBetError: 'O valor da aposta não pode ser superior a 50,00€.',
  },
  nl: {
    // --- Landing (auto-added) ---
    landingTag: 'Voorspellingen onder vrienden',
    landingHead: 'Voorspel samen. Win samen.',
    landingSub: 'Scherenmarket is jouw privé-voorspellingsplatform. Word lid van een organisatie, maak ja/nee-weddenschappen en meet je met vrienden.',
    landingReg: 'Gratis registreren',
    landingLogin: 'Inloggen',
    landingHaveAcc: 'Al lid?',
    f1t: 'Privé-organisaties',
    f1d: 'Je eigen ruimtes – alleen jouw groep ziet de weddenschappen.',
    f2t: 'Weddenschappen maken',
    f2d: 'Ja/nee-voorspellingen over alles.',
    f3t: 'Eerlijk afrekenen',
    f3d: 'Speelgeld of echte PayPal-afrekening – jij beslist.',
    landingFooter: 'Voorspellingsmarkt voor vriendengroepen',
    // --- Organizations & Announcements (auto-added) ---
    orgsTitle: 'Organisaties',
    orgsSubtitle: 'Word lid van een organisatie om haar weddenschappen te zien en mee te doen. Je kunt bij meerdere tegelijk zijn.',
    orgsSearch: 'Organisatie zoeken…',
    orgsCreateBtn: 'Aanmaken',
    orgsNoneFound: 'Geen organisatie gevonden.',
    orgMemberBadge: 'Lid',
    orgRequestedBadge: 'Verzoek verstuurd',
    orgAcceptedBadge: 'Geaccepteerd',
    orgHostBadge: 'Host',
    orgMembersWord: 'leden',
    orgMemberWord: 'lid',
    orgViewMembers: 'bekijken',
    orgJoinBtn: 'Deelnemen',
    orgJoinCode: 'Toegangscode',
    orgEnterCode: 'Voer een toegangscode in.',
    orgRequestJoin: 'Verzoek om lid te worden',
    orgRequestsBtn: 'Verzoeken',
    orgEditBtn: 'Bewerken',
    orgLeaveBtn: 'Verlaten',
    orgLeaveTitle: 'Organisatie verlaten?',
    orgLeaveDesc: 'Je ziet haar weddenschappen dan niet meer en moet mogelijk opnieuw lid worden.',
    orgJoined: 'Lid geworden van de organisatie.',
    orgJoinFailed: 'Deelnemen mislukt.',
    orgRequestSent: 'Verzoek verstuurd – de host moet het goedkeuren.',
    orgRequestFailed: 'Verzoek mislukt.',
    orgLeft: 'Organisatie verlaten.',
    orgLeaveFailed: 'Verlaten mislukt.',
    orgLoadFailed: 'Kon organisaties niet laden.',
    orgRequestsLoadFailed: 'Kon verzoeken niet laden.',
    orgApprovedToast: 'Deelname goedgekeurd.',
    orgRejectedToast: 'Verzoek afgewezen.',
    orgActionFailed: 'Actie mislukt.',
    orgCreateTitle: 'Organisatie aanmaken',
    orgCreateDesc: 'Je wordt automatisch host van je nieuwe organisatie.',
    orgNameLabel: 'Naam',
    orgNameRequired: 'Voer een naam in.',
    orgDescLabel: 'Beschrijving',
    orgDescPlaceholder: 'Waar gaat het over?',
    orgImageLabel: 'Afbeeldings-URL',
    orgImageOptional: 'Afbeeldings-URL (optioneel)',
    orgPolicyLabel: 'Toetreding',
    policyBoth: 'Code of verzoek',
    policyCode: 'Alleen code',
    policyRequest: 'Alleen verzoek',
    orgPaypalBilling: 'PayPal-afrekening',
    orgPlayMoney: 'Speelgeld',
    orgCreated: 'Organisatie aangemaakt.',
    orgCreateFailed: 'Aanmaken mislukt.',
    orgUpdated: 'Organisatie bijgewerkt.',
    orgSaveFailed: 'Opslaan mislukt.',
    orgEditTitle: 'Organisatie bewerken',
    orgMembersTitle: 'Leden',
    orgMembersLoadFailed: 'Kon leden niet laden.',
    orgRemoveMemberTitle: 'Lid verwijderen?',
    orgRemoveMemberDesc: 'Deze persoon verliest de toegang tot deze organisatie.',
    orgMemberRemoved: 'Lid verwijderd.',
    orgRemoveFailed: 'Verwijderen mislukt.',
    orgNoRequests: 'Geen openstaande verzoeken.',
    approveBtn: 'Goedkeuren',
    rejectBtn: 'Afwijzen',
    removeBtn: 'Verwijderen',
    orgAcceptedInfo: 'Je verzoek is geaccepteerd.',
    orgFinishPaypal: 'Voeg je PayPal-link toe om de deelname af te ronden.',
    orgFinishJoin: 'Rond je deelname af.',
    orgJoinWithPaypal: 'Deelnemen met PayPal',
    orgCompleteJoin: 'Deelname afronden',
    orgPaypalRequired: 'PayPal-link vereist.',
    announcementClose: 'Aankondiging sluiten',
    coins: '€',
    balance: 'Winst / verlies',
    netProfitLoss: 'Winst / verlies',
    loading: 'Laden...',
    cancel: 'Annuleer',
    confirm: 'Bevestig',
    save: 'Opslaan',
    saving: 'Opslaan...',
    saveChanges: 'Wijzigingen opslaan',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    back: 'Terug',
    viewAll: 'Bekijk alles',
    search: 'Zoeken',
    add: 'Toevoegen',
    remove: 'Verwijderen',
    create: 'Creëer',
    previous: 'Vorige',
    next: 'Volgende',
    welcomeBack: 'Scherenmarkt',
    signInToAccount: 'Log in',
    email: 'E-mail of gebruikersnaam',
    password: 'Wachtwoord',
    signIn: 'Inloggen',
    signingIn: 'Aanmelden...',
    noAccount: 'Don',
    createOne: 'Maak er een',
    createAccount: 'Account aanmaken',
    joinScherenmarket: 'Doe mee',
    username: 'Gebruikersnaam',
    confirmPassword: 'Bevestig wachtwoord',
    creatingAccount: 'Account aanmaken...',
    hasAccount: 'Heeft u al een account?',
    startWithEuro: 'Je begint met',
    canGoNegative: 'Je begint bij 0 € - zet zoveel in als je wilt!',
    startingCapital: 'Startkapitaal: 0 €',
    markets: 'Markten',
    dashboard: 'Dashboard',
    profile: 'Profiel',
    logout: 'Uitloggen',
    language: 'Taal',
    friends: 'Vrienden',
    groups: 'Groepen',
    toggleTheme: 'Thema wisselen',
    settlements: 'Betalingen en winsten',
    toPay: 'Om te betalen',
    toConfirm: 'Bevestig ontvangst',
    wonBetsOverview: 'Gewonnen weddenschappen',
    settlementHistory: 'Betalingsgeschiedenis',
    noPayoutsToPay: 'Geen openstaande weddenschapsschulden. Goed gedaan!',
    noPayoutsToConfirm: 'Geen openstaande betalingen om te bevestigen.',
    noWonBetsYet: 'Nog geen gewonnen weddenschappen.',
    noPayoutHistory: 'Nog geen betalingsgeschiedenis.',
    amountToPay: 'Bedrag',
    payee: 'Begunstigde',
    payer: 'Betaler',
    openPaypal: 'Betaal met PayPal',
    confirmReceipt: 'Bevestig ontvangst',
    receiptConfirmed: 'Ontvangst bevestigd!',
    statusPending: 'In behandeling',
    statusConfirmed: 'Bevestigd',
    copied: 'Gekopieerd!',
    copyInfo: 'Kopieer informatie',
    pendingSettlementsAlert: 'Er zijn nog openstaande schikkingen! Controleer uw betalingen.',
    welcomeBackUser: 'Welkom terug,',
    tradingOverview: 'Hier',
    createMarket: 'Creëer markt',
    activeBets: 'Actieve weddenschappen',
    activeWager: 'Actieve weddenschap',
    totalBets: 'Totaal aantal weddenschappen',
    winRate: 'Winstpercentage',
    hotMarkets: 'Hete markten',
    yourOpenBets: 'Uw open weddenschappen',
    noOpenBets: 'Geen open weddenschappen. Vind een markt om te beginnen met handelen!',
    leaderboard: 'Leiderbord',
    topTraders: 'Tophandelaren',
    bottomTraders: 'Onderste handelaren',
    browseMarkets: 'Markten',
    browseBet: 'Blader door en gok op voorspellingen',
    searchMarkets: 'Markten zoeken...',
    all: 'Allemaal',
    noMarketsFound: 'Geen markten gevonden',
    noMarketsMatch: 'Er komen geen markten overeen',
    beFirstToCreate: 'Wees de eerste die een markt creëert!',
    backToMarkets: 'Terug naar Markten',
    marketNotFound: 'Markt niet gevonden',
    by: 'door',
    ends: 'Eindigt',
    bets: 'weddenschappen',
    pool: 'zwembad',
    timeRemaining: 'Resterende tijd',
    days: 'Dagen',
    hours: 'Uur',
    mins: 'Min',
    secs: 'Sec',
    yes: 'JA',
    no: 'NEE',
    betYes: 'WEDDEN JA',
    betNo: 'WEDDEN NEE',
    resolveMarket: 'Markt oplossen',
    cancelMarket: 'Markt annuleren',
    cancelMarketConfirm: 'Deze markt echt annuleren? Alle weddenschappen worden terugbetaald.',
    yourBets: 'Jouw weddenschappen',
    pending: 'in afwachting',
    won: 'gewonnen',
    lost: 'verloren',
    refunded: 'terugbetaald',
    potential: 'Potentieel',
    ended: 'Beëindigd',
    visibility: 'Zichtbaarheid',
    visibilityPublic: 'Openbaar',
    visibilityEmailDomain: 'Alleen e-maildomein',
    visibilitySpecificUsers: 'Alleen specifieke gebruikers',
    visibilityGroup: 'Alleen groep',
    emailDomain: 'E-maildomein (bijvoorbeeld stud.uni-goettingen.de)',
    selectUsers: 'Selecteer gebruikers',
    selectGroup: 'Groep selecteren',
    category: 'Categorie',
    categories: 'Categorieën',
    noCategory: 'Geen categorie',
    createCategory: 'Categorie maken',
    achievements: 'Prestaties',
    noAchievements: 'Er zijn nog geen prestaties ontgrendeld.',
    awardedAt: 'Toegekend op',
    categoryName: 'Categorienaam',
    tagUsers: 'Tag gebruikers',
    taggedUsers: 'Getagde gebruikers',
    searchUsers: 'Gebruikers zoeken...',
    userSearch: 'Zoek gebruikers',
    userProfile: 'Gebruikersprofiel',
    memberSince: 'Lid sinds',
    recentBets: 'Recente weddenschappen',
    friendsList: 'Vriendenlijst',
    friendRequests: 'Vriendschapsverzoeken',
    addFriend: 'Vriend toevoegen',
    removeFriend: 'Vriend verwijderen',
    acceptRequest: 'Accepteer',
    rejectRequest: 'Afwijzen',
    requestSent: 'Verzoek verzonden',
    noFriends: 'Nog geen vrienden',
    noPendingRequests: 'Geen openstaande verzoeken',
    editNickname: 'Bijnaam bewerken',
    setNickname: 'Bijnaam instellen',
    nickname: 'Bijnaam',
    nicknameUpdated: 'Bijnaam succesvol bijgewerkt',
    myGroups: 'Mijn groepen',
    createGroup: 'Groep aanmaken',
    groupName: 'Groepsnaam',
    groupDescription: 'Beschrijving',
    groupMembers: 'Leden',
    addMembers: 'Leden toevoegen',
    leaveGroup: 'Verlaat de groep',
    noGroups: 'Nog geen groepen',
    copyInviteLink: 'Kopieer de uitnodigingslink',
    copyLinkManually: 'Koppeling handmatig kopiëren:',
    close: 'Sluiten',
    inviteLinkCopied: 'Uitnodigingslink gekopieerd naar klembord!',
    failedToCopyInviteLink: 'Kan de uitnodigingslink niet kopiëren',
    groupJoined: 'Succesvol lid geworden van de groep!',
    joiningGroup: 'Deelnemen aan groep...',
    invalidInviteLink: 'Ongeldige uitnodigingslink',
    alreadyMember: 'Je bent al lid van deze groep',
    error: 'Fout',
    backToFriends: 'Terug naar Vrienden',
    placeBet: 'Plaats een weddenschap',
    betAmount: 'Inzetbedrag',
    yourBalance: 'Uw winst/verlies',
    placingBet: 'Plaatsen...',
    betOn: 'Zet in op',
    selectWinner: 'Selecteer de winnende uitkomst. Deze actie kan niet ongedaan worden gemaakt.',
    yesWon: 'JA gewonnen',
    noWon: 'NEE gewonnen',
    marketResolved: 'Markt opgelost',
    marketCancelled: 'Markt geannuleerd',
    winners: 'Winnaars',
    totalPayout: 'Totale uitbetaling',
    winnersList: 'Winnaars Lijst',
    noWinners: 'Geen winnaars',
    payout: 'Uitbetaling',
    createAMarket: 'Creëer een markt',
    createYesNo: 'Creëer een ja/nee-voorspellingsmarkt waar anderen op kunnen wedden',
    questionTitle: 'Vraag / Titel',
    questionPlaceholder: 'Zal Bitcoin tegen eind 2024 $100.000 bereiken?',
    descriptionOptional: 'Beschrijving (optioneel)',
    descriptionPlaceholder: 'Voeg meer context toe over deze voorspelling...',
    endDateTime: 'Einddatum en -tijd',
    pickDateTime: 'Kies datum en tijd',
    marketWillClose: 'De markt zal op dit moment sluiten',
    tipsTitle: 'Tips voor een goede markt:',
    tip1: 'Maak de vraag duidelijk en ondubbelzinnig',
    tip2: 'Stel een realistische einddatum vast',
    tip3: 'Voeg een beschrijving voor context toe',
    tip4: 'Jij',
    creating: 'Creëren...',
    transactions: 'Transacties',
    betHistory: 'Wedgeschiedenis',
    noBetsYet: 'Nog geen weddenschappen. Begin met handelen!',
    noTransactions: 'Nog geen transacties.',
    balanceOverTime: 'Winst/verlies in de loop van de tijd',
    betResults: 'Inzetresultaten',
    statusOpen: 'Openen',
    statusClosed: 'Gesloten',
    statusResolved: 'Opgelost',
    statusCancelled: 'Geannuleerd',
    loginFailed: 'Inloggen mislukt',
    registrationFailed: 'Registratie mislukt',
    passwordsNoMatch: 'Wachtwoorden komen niet overeen',
    passwordTooShort: 'Wachtwoord moet minimaal 6 tekens lang zijn',
    invalidBetAmount: 'Ongeldig inzetbedrag',
    marketCreationFailed: 'Het is niet gelukt een markt te creëren',
    betPlacementFailed: 'Kan geen weddenschap plaatsen',
    welcomeMessage: 'Welkom terug!',
    accountCreated: 'Welkom bij Scherenmarkt!',
    marketCreated: 'Markt succesvol gecreëerd!',
    betPlaced: 'Inzet geplaatst',
    marketResolvedSuccess: 'Markt succesvol opgelost',
    marketCancelledSuccess: 'Markt geannuleerd, weddenschappen terugbetaald',
    friendRequestSent: 'Vriendschapsverzoek verzonden',
    friendRequestAccepted: 'Vriendschapsverzoek geaccepteerd',
    friendRemoved: 'Vriend verwijderd',
    groupCreated: 'Groep gemaakt',
    categoryCreated: 'Categorie aangemaakt',
    isTieredBet: 'Creëer een gedifferentieerde weddenschap',
    tieredOptions: 'Gelaagde inzetopties',
    titleTemplate: 'Titelsjabloon (gebruik (VALUE) als tijdelijke aanduiding)',
    titleTemplatePlaceholder: 'Zal Bitcoin boven (VALUE) € uitkomen?',
    thresholdMode: 'Drempelinvoermodus',
    thresholdModeRange: 'Bereik (begin, einde, stap)',
    thresholdModeManual: 'Handmatige lijst (door komma\'s gescheiden)',
    startValue: 'Beginwaarde',
    endValue: 'Eindwaarde',
    stepSize: 'Stapgrootte/interval',
    manualThresholds: 'Drempels (bijvoorbeeld 2000, 5000, 10000)',
    manualThresholdsPlaceholder: 'Voer drempelwaarden in, gescheiden door komma\'s...',
    invalidThresholds: 'Voer geldige drempelwaarden in.',
    tieredMarkets: 'Drempels in deze serie',
    threshold: 'Drempel',
    currentTier: 'Huidig niveau',
    minBetAmount: 'Minimum inzetbedrag (€)',
    minBetAmountPlaceholder: 'bijv. 5',
    minBetAmountHint: 'De gastheer kan het startinzetbedrag instellen. Maximaal 50 €.',
    maxBetError: 'Het inzetbedrag kan niet groter zijn dan € 50,00.',
  },
  pl: {
    // --- Landing (auto-added) ---
    landingTag: 'Prognozy wśród znajomych',
    landingHead: 'Typujcie razem. Wygrywajcie razem.',
    landingSub: 'Scherenmarket to Twoja prywatna platforma prognoz. Dołącz do organizacji, twórz zakłady tak/nie i rywalizuj ze znajomymi.',
    landingReg: 'Zarejestruj się za darmo',
    landingLogin: 'Zaloguj się',
    landingHaveAcc: 'Już masz konto?',
    f1t: 'Prywatne organizacje',
    f1d: 'Własne przestrzenie – tylko Twoja grupa widzi zakłady.',
    f2t: 'Twórz zakłady',
    f2d: 'Prognozy tak/nie na dowolny temat.',
    f3t: 'Rozliczaj uczciwie',
    f3d: 'Wirtualne pieniądze lub prawdziwe rozliczenie PayPal – Ty decydujesz.',
    landingFooter: 'Rynek prognoz dla grup znajomych',
    // --- Organizations & Announcements (auto-added) ---
    orgsTitle: 'Organizacje',
    orgsSubtitle: 'Dołącz do organizacji, aby widzieć jej zakłady i brać w nich udział. Możesz należeć do kilku naraz.',
    orgsSearch: 'Szukaj organizacji…',
    orgsCreateBtn: 'Utwórz',
    orgsNoneFound: 'Nie znaleziono organizacji.',
    orgMemberBadge: 'Członek',
    orgRequestedBadge: 'Wysłano prośbę',
    orgAcceptedBadge: 'Zaakceptowano',
    orgHostBadge: 'Host',
    orgMembersWord: 'członków',
    orgMemberWord: 'członek',
    orgViewMembers: 'zobacz',
    orgJoinBtn: 'Dołącz',
    orgJoinCode: 'Kod dostępu',
    orgEnterCode: 'Wpisz kod dostępu.',
    orgRequestJoin: 'Poproś o dołączenie',
    orgRequestsBtn: 'Prośby',
    orgEditBtn: 'Edytuj',
    orgLeaveBtn: 'Opuść',
    orgLeaveTitle: 'Opuścić organizację?',
    orgLeaveDesc: 'Nie będziesz już widzieć jej zakładów i możesz musieć dołączyć ponownie.',
    orgJoined: 'Dołączono do organizacji.',
    orgJoinFailed: 'Nie udało się dołączyć.',
    orgRequestSent: 'Prośba wysłana – host musi ją zatwierdzić.',
    orgRequestFailed: 'Prośba nie powiodła się.',
    orgLeft: 'Opuszczono organizację.',
    orgLeaveFailed: 'Nie udało się opuścić.',
    orgLoadFailed: 'Nie udało się wczytać organizacji.',
    orgRequestsLoadFailed: 'Nie udało się wczytać próśb.',
    orgApprovedToast: 'Dołączenie zatwierdzone.',
    orgRejectedToast: 'Prośba odrzucona.',
    orgActionFailed: 'Akcja nie powiodła się.',
    orgCreateTitle: 'Utwórz organizację',
    orgCreateDesc: 'Automatycznie zostaniesz hostem swojej nowej organizacji.',
    orgNameLabel: 'Nazwa',
    orgNameRequired: 'Wpisz nazwę.',
    orgDescLabel: 'Opis',
    orgDescPlaceholder: 'O co chodzi?',
    orgImageLabel: 'URL obrazu',
    orgImageOptional: 'URL obrazu (opcjonalnie)',
    orgPolicyLabel: 'Dołączanie',
    policyBoth: 'Kod lub prośba',
    policyCode: 'Tylko kod',
    policyRequest: 'Tylko prośba',
    orgPaypalBilling: 'Rozliczenia PayPal',
    orgPlayMoney: 'Wirtualne pieniądze',
    orgCreated: 'Organizacja utworzona.',
    orgCreateFailed: 'Nie udało się utworzyć.',
    orgUpdated: 'Organizacja zaktualizowana.',
    orgSaveFailed: 'Nie udało się zapisać.',
    orgEditTitle: 'Edytuj organizację',
    orgMembersTitle: 'Członkowie',
    orgMembersLoadFailed: 'Nie udało się wczytać członków.',
    orgRemoveMemberTitle: 'Usunąć członka?',
    orgRemoveMemberDesc: 'Ta osoba straci dostęp do tej organizacji.',
    orgMemberRemoved: 'Członek usunięty.',
    orgRemoveFailed: 'Nie udało się usunąć.',
    orgNoRequests: 'Brak oczekujących próśb.',
    approveBtn: 'Zatwierdź',
    rejectBtn: 'Odrzuć',
    removeBtn: 'Usuń',
    orgAcceptedInfo: 'Twoja prośba została zaakceptowana.',
    orgFinishPaypal: 'Dodaj swój link PayPal, aby dokończyć dołączanie.',
    orgFinishJoin: 'Dokończ dołączanie.',
    orgJoinWithPaypal: 'Dołącz z PayPal',
    orgCompleteJoin: 'Dokończ dołączanie',
    orgPaypalRequired: 'Wymagany link PayPal.',
    announcementClose: 'Zamknij ogłoszenie',
    coins: '€',
    balance: 'Zysk / strata',
    netProfitLoss: 'Zysk / strata',
    loading: 'Ładowanie...',
    cancel: 'Anuluj',
    confirm: 'Potwierdź',
    save: 'Zapisz',
    saving: 'Zapisywanie...',
    saveChanges: 'Zapisz zmiany',
    delete: 'Usuń',
    edit: 'Edytuj',
    back: 'Powrót',
    viewAll: 'Zobacz wszystkie',
    search: 'Szukaj',
    add: 'Dodaj',
    remove: 'Usuń',
    create: 'Utwórz',
    previous: 'Poprzedni',
    next: 'Następny',
    welcomeBack: 'Scherenmarket',
    signInToAccount: 'Zaloguj się',
    email: 'E-mail lub nazwa użytkownika',
    password: 'Hasło',
    signIn: 'Zaloguj się',
    signingIn: 'Logowanie...',
    noAccount: 'Don',
    createOne: 'Utwórz jeden',
    createAccount: 'Utwórz konto',
    joinScherenmarket: 'Dołącz',
    username: 'Nazwa użytkownika',
    confirmPassword: 'Potwierdź hasło',
    creatingAccount: 'Tworzenie konta...',
    hasAccount: 'Masz już konto?',
    startWithEuro: 'Zaczynasz od',
    canGoNegative: 'Zaczynasz od 0 € - obstawiaj tyle, ile chcesz!',
    startingCapital: 'Kapitał początkowy: 0 €',
    markets: 'Rynki',
    dashboard: 'Pulpit nawigacyjny',
    profile: 'Profil',
    logout: 'Wyloguj się',
    language: 'Język',
    friends: 'Przyjaciele',
    groups: 'Grupy',
    toggleTheme: 'Przełącz motyw',
    settlements: 'Płatności i wygrane',
    toPay: 'Aby zapłacić',
    toConfirm: 'Potwierdź odbiór',
    wonBetsOverview: 'Wygrane zakłady',
    settlementHistory: 'Historia płatności',
    noPayoutsToPay: 'Brak zaległych długów zakładowych. Dobrze zrobiony!',
    noPayoutsToConfirm: 'Brak oczekujących płatności do potwierdzenia.',
    noWonBetsYet: 'Nie ma jeszcze żadnych wygranych zakładów.',
    noPayoutHistory: 'Nie ma jeszcze historii płatności.',
    amountToPay: 'Kwota',
    payee: 'Odbiorca płatności',
    payer: 'Płatnik',
    openPaypal: 'Zapłać za pomocą PayPal',
    confirmReceipt: 'Potwierdź odbiór',
    receiptConfirmed: 'Odbiór potwierdzony!',
    statusPending: 'Oczekujące',
    statusConfirmed: 'Potwierdzone',
    copied: 'Skopiowano!',
    copyInfo: 'Kopiuj informacje',
    pendingSettlementsAlert: 'Masz oczekujące rozliczenia! Sprawdź swoje płatności.',
    welcomeBackUser: 'Witamy ponownie,',
    tradingOverview: 'Tutaj',
    createMarket: 'Utwórz rynek',
    activeBets: 'Aktywne zakłady',
    activeWager: 'Aktywny zakład',
    totalBets: 'Łączna liczba zakładów',
    winRate: 'Współczynnik wygranych',
    hotMarkets: 'Gorące rynki',
    yourOpenBets: 'Twoje otwarte zakłady',
    noOpenBets: 'Brak otwartych zakładów. Znajdź rynek, aby rozpocząć handel!',
    leaderboard: 'Tabela liderów',
    topTraders: 'Najlepsi handlowcy',
    bottomTraders: 'Handlowcy z dołu',
    browseMarkets: 'Rynki',
    browseBet: 'Przeglądaj i obstawiaj prognozy',
    searchMarkets: 'Przeszukaj rynki...',
    all: 'Wszystko',
    noMarketsFound: 'Nie znaleziono rynków',
    noMarketsMatch: 'Żaden rynek nie pasuje',
    beFirstToCreate: 'Bądź pierwszym, który stworzy rynek!',
    backToMarkets: 'Powrót do rynków',
    marketNotFound: 'Nie znaleziono rynku',
    by: 'przez',
    ends: 'Kończy się',
    bets: 'zakłady',
    pool: 'basen',
    timeRemaining: 'Pozostały czas',
    days: 'Dni',
    hours: 'Godziny',
    mins: 'Min',
    secs: 'sek',
    yes: 'TAK',
    no: 'NIE',
    betYes: 'ZAKŁAD TAK',
    betNo: 'ZAKŁAD NIE',
    resolveMarket: 'Rozwiąż rynek',
    cancelMarket: 'Anuluj rynek',
    cancelMarketConfirm: 'Naprawdę anulować ten rynek? Wszystkie zakłady zostaną zwrócone.',
    yourBets: 'Twoje zakłady',
    pending: 'w toku',
    won: 'wygrał',
    lost: 'zgubiony',
    refunded: 'zwrócone',
    potential: 'Potencjał',
    ended: 'Zakończone',
    visibility: 'Widoczność',
    visibilityPublic: 'Publiczne',
    visibilityEmailDomain: 'Tylko domena e-mail',
    visibilitySpecificUsers: 'Tylko określeni użytkownicy',
    visibilityGroup: 'Tylko grupa',
    emailDomain: 'Domena e-mail (np. stud.uni-goettingen.de)',
    selectUsers: 'Wybierz użytkowników',
    selectGroup: 'Wybierz grupę',
    category: 'Kategoria',
    categories: 'Kategorie',
    noCategory: 'Brak kategorii',
    createCategory: 'Utwórz kategorię',
    achievements: 'Osiągnięcia',
    noAchievements: 'Nie odblokowano jeszcze żadnych osiągnięć.',
    awardedAt: 'Nagrodzony dnia',
    categoryName: 'Nazwa kategorii',
    tagUsers: 'Oznacz użytkowników',
    taggedUsers: 'Otagowani użytkownicy',
    searchUsers: 'Wyszukaj użytkowników...',
    userSearch: 'Wyszukaj użytkowników',
    userProfile: 'Profil użytkownika',
    memberSince: 'Członek od',
    recentBets: 'Ostatnie zakłady',
    friendsList: 'Lista znajomych',
    friendRequests: 'Prośby o znajomych',
    addFriend: 'Dodaj znajomego',
    removeFriend: 'Usuń znajomego',
    acceptRequest: 'Zaakceptuj',
    rejectRequest: 'Odrzuć',
    requestSent: 'Zapytanie wysłane',
    noFriends: 'Nie ma jeszcze żadnych przyjaciół',
    noPendingRequests: 'Brak oczekujących żądań',
    editNickname: 'Edytuj pseudonim',
    setNickname: 'Ustaw pseudonim',
    nickname: 'Pseudonim',
    nicknameUpdated: 'Pseudonim został pomyślnie zaktualizowany',
    myGroups: 'Moje grupy',
    createGroup: 'Utwórz grupę',
    groupName: 'Nazwa grupy',
    groupDescription: 'Opis',
    groupMembers: 'Członkowie',
    addMembers: 'Dodaj członków',
    leaveGroup: 'Opuść grupę',
    noGroups: 'Nie ma jeszcze grup',
    copyInviteLink: 'Skopiuj link z zaproszeniem',
    copyLinkManually: 'Skopiuj link ręcznie:',
    close: 'Zamknij',
    inviteLinkCopied: 'Link zaproszenia skopiowany do schowka!',
    failedToCopyInviteLink: 'Nie udało się skopiować linku z zaproszeniem',
    groupJoined: 'Pomyślnie dołączyłeś do grupy!',
    joiningGroup: 'Dołączam do grupy...',
    invalidInviteLink: 'Nieprawidłowy link z zaproszeniem',
    alreadyMember: 'Jesteś już członkiem tej grupy',
    error: 'Błąd',
    backToFriends: 'Powrót do Przyjaciół',
    placeBet: 'Postaw zakład',
    betAmount: 'Kwota zakładu',
    yourBalance: 'Twój zysk/strata',
    placingBet: 'Umieszczanie...',
    betOn: 'Postaw na',
    selectWinner: 'Wybierz zwycięski wynik. Tej akcji nie można cofnąć.',
    yesWon: 'TAK Wygrane',
    noWon: 'NIE Wygrane',
    marketResolved: 'Rynek rozwiązany',
    marketCancelled: 'Rynek odwołany',
    winners: 'Zwycięzcy',
    totalPayout: 'Całkowita wypłata',
    winnersList: 'Lista zwycięzców',
    noWinners: 'Żadnych zwycięzców',
    payout: 'Wypłata',
    createAMarket: 'Stwórz rynek',
    createYesNo: 'Utwórz rynek przewidywań typu „tak/nie”, aby inni mogli na nim obstawiać',
    questionTitle: 'Pytanie/tytuł',
    questionPlaceholder: 'Czy Bitcoin osiągnie 100 tys. dolarów do końca 2024 roku?',
    descriptionOptional: 'Opis (opcjonalnie)',
    descriptionPlaceholder: 'Dodaj więcej kontekstu do tej prognozy...',
    endDateTime: 'Data i godzina zakończenia',
    pickDateTime: 'Wybierz datę i godzinę',
    marketWillClose: 'W tym czasie rynek zostanie zamknięty',
    tipsTitle: 'Wskazówki dotyczące dobrego rynku:',
    tip1: 'Uczyń pytanie jasnym i jednoznacznym',
    tip2: 'Ustaw realistyczną datę zakończenia',
    tip3: 'Dodaj opis kontekstu',
    tip4: 'Ty',
    creating: 'Tworzenie...',
    transactions: 'Transakcje',
    betHistory: 'Historia zakładów',
    noBetsYet: 'Nie ma jeszcze żadnych zakładów. Zacznij handlować!',
    noTransactions: 'Nie ma jeszcze żadnych transakcji.',
    balanceOverTime: 'Zysk/strata w czasie',
    betResults: 'Wyniki zakładów',
    statusOpen: 'Otwórz',
    statusClosed: 'Zamknięte',
    statusResolved: 'Rozwiązano',
    statusCancelled: 'Anulowano',
    loginFailed: 'Logowanie nie powiodło się',
    registrationFailed: 'Rejestracja nie powiodła się',
    passwordsNoMatch: 'Hasła nie pasują',
    passwordTooShort: 'Hasło musi mieć co najmniej 6 znaków',
    invalidBetAmount: 'Nieprawidłowa kwota zakładu',
    marketCreationFailed: 'Nie udało się utworzyć rynku',
    betPlacementFailed: 'Nie udało się postawić zakładu',
    welcomeMessage: 'Witamy ponownie!',
    accountCreated: 'Witamy w Scherenmarket!',
    marketCreated: 'Rynek został utworzony pomyślnie!',
    betPlaced: 'Zakład postawiony',
    marketResolvedSuccess: 'Rynek rozwiązany pomyślnie',
    marketCancelledSuccess: 'Rynek anulowany, zakłady zwrócone',
    friendRequestSent: 'Wysłano zaproszenie do grona znajomych',
    friendRequestAccepted: 'Zaproszenie do grona znajomych zaakceptowane',
    friendRemoved: 'Przyjaciel usunięty',
    groupCreated: 'Grupa utworzona',
    categoryCreated: 'Kategoria utworzona',
    isTieredBet: 'Utwórz zakład wielopoziomowy',
    tieredOptions: 'Opcje zakładów wielopoziomowych',
    titleTemplate: 'Szablon tytułu (użyj (VALUE) jako symbolu zastępczego)',
    titleTemplatePlaceholder: 'Czy Bitcoin będzie powyżej (VALUE) €?',
    thresholdMode: 'Tryb wejścia progowego',
    thresholdModeRange: 'Zakres (początek, koniec, krok)',
    thresholdModeManual: 'Lista ręczna (oddzielona przecinkami)',
    startValue: 'Wartość początkowa',
    endValue: 'Wartość końcowa',
    stepSize: 'Rozmiar kroku/interwał',
    manualThresholds: 'Progi (np. 2000, 5000, 10000)',
    manualThresholdsPlaceholder: 'Wprowadź progi oddzielone przecinkami...',
    invalidThresholds: 'Proszę wprowadzić prawidłowe wartości progowe.',
    tieredMarkets: 'Progi z tej serii',
    threshold: 'Próg',
    currentTier: 'Aktualny poziom',
    minBetAmount: 'Minimalna kwota zakładu (€)',
    minBetAmountPlaceholder: 'np. 5',
    minBetAmountHint: 'Gospodarz może ustawić początkową kwotę zakładu. Maksymalnie 50 €.',
    maxBetError: 'Kwota zakładu nie może być większa niż 50,00 €.',
  },
  tr: {
    // --- Landing (auto-added) ---
    landingTag: 'Arkadaşlar arası tahminler',
    landingHead: 'Birlikte tahmin edin. Birlikte kazanın.',
    landingSub: 'Scherenmarket özel tahmin platformunuz. Bir organizasyona katılın, evet/hayır bahisleri oluşturun ve arkadaşlarınızla yarışın.',
    landingReg: 'Ücretsiz kayıt ol',
    landingLogin: 'Giriş yap',
    landingHaveAcc: 'Zaten üye misin?',
    f1t: 'Özel organizasyonlar',
    f1d: 'Kendi alanların – bahisleri yalnızca grubun görür.',
    f2t: 'Bahis oluştur',
    f2d: 'Her konuda evet/hayır tahminleri.',
    f3t: 'Adil hesaplaş',
    f3d: 'Sanal para ya da gerçek PayPal ödemesi – sen karar ver.',
    landingFooter: 'Arkadaş grupları için tahmin pazarı',
    // --- Organizations & Announcements (auto-added) ---
    orgsTitle: 'Organizasyonlar',
    orgsSubtitle: 'Bahislerini görmek ve katılmak için bir organizasyona katıl. Aynı anda birden fazlasında olabilirsin.',
    orgsSearch: 'Organizasyon ara…',
    orgsCreateBtn: 'Oluştur',
    orgsNoneFound: 'Organizasyon bulunamadı.',
    orgMemberBadge: 'Üye',
    orgRequestedBadge: 'İstek gönderildi',
    orgAcceptedBadge: 'Kabul edildi',
    orgHostBadge: 'Yönetici',
    orgMembersWord: 'üye',
    orgMemberWord: 'üye',
    orgViewMembers: 'görüntüle',
    orgJoinBtn: 'Katıl',
    orgJoinCode: 'Katılım kodu',
    orgEnterCode: 'Lütfen bir katılım kodu gir.',
    orgRequestJoin: 'Katılım isteği gönder',
    orgRequestsBtn: 'İstekler',
    orgEditBtn: 'Düzenle',
    orgLeaveBtn: 'Ayrıl',
    orgLeaveTitle: 'Organizasyondan ayrıl?',
    orgLeaveDesc: 'Artık bahislerini göremezsin ve yeniden katılman gerekebilir.',
    orgJoined: 'Organizasyona katıldın.',
    orgJoinFailed: 'Katılım başarısız.',
    orgRequestSent: 'İstek gönderildi – yöneticinin onaylaması gerekiyor.',
    orgRequestFailed: 'İstek başarısız.',
    orgLeft: 'Organizasyondan ayrıldın.',
    orgLeaveFailed: 'Ayrılma başarısız.',
    orgLoadFailed: 'Organizasyonlar yüklenemedi.',
    orgRequestsLoadFailed: 'İstekler yüklenemedi.',
    orgApprovedToast: 'Katılım onaylandı.',
    orgRejectedToast: 'İstek reddedildi.',
    orgActionFailed: 'İşlem başarısız.',
    orgCreateTitle: 'Organizasyon oluştur',
    orgCreateDesc: 'Yeni organizasyonunun otomatik olarak yöneticisi olursun.',
    orgNameLabel: 'Ad',
    orgNameRequired: 'Lütfen bir ad gir.',
    orgDescLabel: 'Açıklama',
    orgDescPlaceholder: 'Ne hakkında?',
    orgImageLabel: 'Görsel URL',
    orgImageOptional: 'Görsel URL (isteğe bağlı)',
    orgPolicyLabel: 'Katılım',
    policyBoth: 'Kod veya istek',
    policyCode: 'Sadece kod',
    policyRequest: 'Sadece istek',
    orgPaypalBilling: 'PayPal ödemesi',
    orgPlayMoney: 'Sanal para',
    orgCreated: 'Organizasyon oluşturuldu.',
    orgCreateFailed: 'Oluşturma başarısız.',
    orgUpdated: 'Organizasyon güncellendi.',
    orgSaveFailed: 'Kaydetme başarısız.',
    orgEditTitle: 'Organizasyonu düzenle',
    orgMembersTitle: 'Üyeler',
    orgMembersLoadFailed: 'Üyeler yüklenemedi.',
    orgRemoveMemberTitle: 'Üye kaldırılsın mı?',
    orgRemoveMemberDesc: 'Bu kişi bu organizasyona erişimini kaybeder.',
    orgMemberRemoved: 'Üye kaldırıldı.',
    orgRemoveFailed: 'Kaldırma başarısız.',
    orgNoRequests: 'Bekleyen istek yok.',
    approveBtn: 'Onayla',
    rejectBtn: 'Reddet',
    removeBtn: 'Kaldır',
    orgAcceptedInfo: 'İsteğin kabul edildi.',
    orgFinishPaypal: 'Katılımı tamamlamak için PayPal bağlantını ekle.',
    orgFinishJoin: 'Katılımını tamamla.',
    orgJoinWithPaypal: 'PayPal ile katıl',
    orgCompleteJoin: 'Katılımı tamamla',
    orgPaypalRequired: 'PayPal bağlantısı gerekli.',
    announcementClose: 'Duyuruyu kapat',
    coins: '€',
    balance: 'Kar / Zarar',
    netProfitLoss: 'Kar / Zarar',
    loading: 'Yükleniyor...',
    cancel: 'İptal',
    confirm: 'Onayla',
    save: 'Kaydet',
    saving: 'Kaydediliyor...',
    saveChanges: 'Değişiklikleri Kaydet',
    delete: 'Sil',
    edit: 'Düzenle',
    back: 'Geri',
    viewAll: 'Tümünü görüntüle',
    search: 'Ara',
    add: 'Ekle',
    remove: 'Kaldır',
    create: 'Oluştur',
    previous: 'Önceki',
    next: 'Sonraki',
    welcomeBack: 'Scherenmarket',
    signInToAccount: 'Oturum aç',
    email: 'E-posta veya Kullanıcı Adı',
    password: 'Şifre',
    signIn: 'Oturum aç',
    signingIn: 'Oturum açılıyor...',
    noAccount: 'Don',
    createOne: 'Bir tane oluştur',
    createAccount: 'Hesap Oluştur',
    joinScherenmarket: 'Katıl',
    username: 'Kullanıcı adı',
    confirmPassword: 'Şifreyi Onayla',
    creatingAccount: 'Hesap oluşturuluyor...',
    hasAccount: 'Zaten bir hesabınız var mı?',
    startWithEuro: 'Şununla başla:',
    canGoNegative: '0 €\'dan başlıyorsunuz - istediğiniz kadar bahis yapın!',
    startingCapital: 'Başlangıç Sermayesi: 0 €',
    markets: 'Piyasalar',
    dashboard: 'Kontrol Paneli',
    profile: 'Profil',
    logout: 'Oturumu kapat',
    language: 'Dil',
    friends: 'Arkadaşlar',
    groups: 'Gruplar',
    toggleTheme: 'Temayı Değiştir',
    settlements: 'Ödemeler ve Kazançlar',
    toPay: 'Ödemek',
    toConfirm: 'Makbuzu Onayla',
    wonBetsOverview: 'Kazanılan Bahisler',
    settlementHistory: 'Ödeme Geçmişi',
    noPayoutsToPay: 'Ödenmemiş bahis borcu yok. Tebrikler!',
    noPayoutsToConfirm: 'Onaylanacak bekleyen ödeme yok.',
    noWonBetsYet: 'Henüz kazanılan bahis yok.',
    noPayoutHistory: 'Henüz ödeme geçmişi yok.',
    amountToPay: 'Tutar',
    payee: 'Alacaklı',
    payer: 'Ödeyen',
    openPaypal: 'PayPal ile ödeme yapın',
    confirmReceipt: 'Makbuzu Onayla',
    receiptConfirmed: 'Makbuz onaylandı!',
    statusPending: 'Beklemede',
    statusConfirmed: 'Onaylandı',
    copied: 'Kopyalandı!',
    copyInfo: 'Bilgileri Kopyala',
    pendingSettlementsAlert: 'Bekleyen ödemeleriniz var! Lütfen ödemelerinizi kontrol ediniz.',
    welcomeBackUser: 'Tekrar hoş geldiniz,',
    tradingOverview: 'Burada',
    createMarket: 'Pazar Oluştur',
    activeBets: 'Aktif Bahisler',
    activeWager: 'Aktif Bahis',
    totalBets: 'Toplam Bahisler',
    winRate: 'Kazanma Oranı',
    hotMarkets: 'Sıcak Piyasalar',
    yourOpenBets: 'Açık Bahisleriniz',
    noOpenBets: 'Açık bahis yok. Ticarete başlamak için bir pazar bulun!',
    leaderboard: 'Liderlik tablosu',
    topTraders: 'En İyi Yatırımcılar',
    bottomTraders: 'Alt Yatırımcılar',
    browseMarkets: 'Piyasalar',
    browseBet: 'Tahminlere göz atın ve bahis yapın',
    searchMarkets: 'Pazarları arayın...',
    all: 'Hepsi',
    noMarketsFound: 'Pazar bulunamadı',
    noMarketsMatch: 'Pazar eşleşmesi yok',
    beFirstToCreate: 'Pazar yaratan ilk siz olun!',
    backToMarkets: 'Piyasalara Geri Dön',
    marketNotFound: 'Pazar bulunamadı',
    by: 'tarafından',
    ends: 'biter',
    bets: 'bahisler',
    pool: 'havuz',
    timeRemaining: 'Kalan Süre',
    days: 'Günler',
    hours: 'Saatler',
    mins: 'Dakika',
    secs: 'saniye',
    yes: 'EVET',
    no: 'HAYIR',
    betYes: 'BAHİS EVET',
    betNo: 'BAHİS YOK',
    resolveMarket: 'Piyasayı Çöz',
    cancelMarket: 'Piyasayı İptal Et',
    cancelMarketConfirm: 'Bu pazar gerçekten iptal mi edilecek? Tüm bahisler iade edilecektir.',
    yourBets: 'Bahisleriniz',
    pending: 'beklemede',
    won: 'kazandı',
    lost: 'kayıp',
    refunded: 'iade edildi',
    potential: 'Potansiyel',
    ended: 'Sona erdi',
    visibility: 'Görünürlük',
    visibilityPublic: 'halka açık',
    visibilityEmailDomain: 'Yalnızca e-posta alanı',
    visibilitySpecificUsers: 'Yalnızca belirli kullanıcılar',
    visibilityGroup: 'Yalnızca grup',
    emailDomain: 'E-posta alanı (ör. stud.uni-goettingen.de)',
    selectUsers: 'Kullanıcıları seçin',
    selectGroup: 'Grup seç',
    category: 'Kategori',
    categories: 'Kategoriler',
    noCategory: 'Kategori yok',
    createCategory: 'Kategori Oluştur',
    achievements: 'Başarılar',
    noAchievements: 'Henüz hiçbir başarının kilidi açılmadı.',
    awardedAt: 'Ödül tarihi',
    categoryName: 'Kategori adı',
    tagUsers: 'Kullanıcıları etiketleyin',
    taggedUsers: 'Etiketlenen kullanıcılar',
    searchUsers: 'Kullanıcıları ara...',
    userSearch: 'Kullanıcıları Ara',
    userProfile: 'Kullanıcı Profili',
    memberSince: 'Şu tarihten beri üye:',
    recentBets: 'Son Bahisler',
    friendsList: 'Arkadaş Listesi',
    friendRequests: 'Arkadaşlık İstekleri',
    addFriend: 'Arkadaş Ekle',
    removeFriend: 'Arkadaşı Kaldır',
    acceptRequest: 'Kabul et',
    rejectRequest: 'Reddet',
    requestSent: 'İstek gönderildi',
    noFriends: 'Henüz arkadaş yok',
    noPendingRequests: 'Bekleyen istek yok',
    editNickname: 'Takma Adı Düzenle',
    setNickname: 'Takma Ad Belirle',
    nickname: 'Takma ad',
    nicknameUpdated: 'Takma ad başarıyla güncellendi',
    myGroups: 'Gruplarım',
    createGroup: 'Grup Oluştur',
    groupName: 'Grup adı',
    groupDescription: 'Açıklama',
    groupMembers: 'Üyeler',
    addMembers: 'Üye ekle',
    leaveGroup: 'Gruptan ayrıl',
    noGroups: 'Henüz grup yok',
    copyInviteLink: 'Davet bağlantısını kopyala',
    copyLinkManually: 'Bağlantıyı manuel olarak kopyala:',
    close: 'Kapat',
    inviteLinkCopied: 'Davet bağlantısı panoya kopyalandı!',
    failedToCopyInviteLink: 'Davet bağlantısı kopyalanamadı',
    groupJoined: 'Gruba başarıyla katıldık!',
    joiningGroup: 'Gruba katılıyoruz...',
    invalidInviteLink: 'Geçersiz davet bağlantısı',
    alreadyMember: 'Zaten bu grubun bir üyesisiniz',
    error: 'Hata',
    backToFriends: 'Arkadaşlara Geri Dön',
    placeBet: 'Bahis Yap',
    betAmount: 'Bahis Tutarı',
    yourBalance: 'Kârınız/Zararınız',
    placingBet: 'Yerleştirme...',
    betOn: 'Bahis',
    selectWinner: 'Kazanan sonucu seçin. Bu eylem geri alınamaz.',
    yesWon: 'EVET Kazanıldı',
    noWon: 'HAYIR Kazanıldı',
    marketResolved: 'Piyasa Çözüldü',
    marketCancelled: 'Piyasa İptal Edildi',
    winners: 'Kazananlar',
    totalPayout: 'Toplam Ödeme',
    winnersList: 'Kazananlar Listesi',
    noWinners: 'Kazanan yok',
    payout: 'Ödeme',
    createAMarket: 'Pazar Oluşturun',
    createYesNo: 'Başkalarının bahis oynayabileceği bir evet/hayır tahmin pazarı oluşturun',
    questionTitle: 'Soru / Başlık',
    questionPlaceholder: 'Bitcoin 2024\'ün sonunda 100 bin dolara ulaşacak mı?',
    descriptionOptional: 'Açıklama (İsteğe bağlı)',
    descriptionPlaceholder: 'Bu tahminle ilgili daha fazla bağlam ekleyin...',
    endDateTime: 'Bitiş Tarihi ve Saati',
    pickDateTime: 'Tarih ve saati seçin',
    marketWillClose: 'Piyasa bu saatte kapanacak',
    tipsTitle: 'İyi bir pazar için ipuçları:',
    tip1: 'Soruyu açık ve net bir şekilde belirtin',
    tip2: 'Gerçekçi bir bitiş tarihi belirleyin',
    tip3: 'Bağlam için açıklama ekleyin',
    tip4: 'sen',
    creating: 'Oluşturuluyor...',
    transactions: 'İşlemler',
    betHistory: 'Bahis Geçmişi',
    noBetsYet: 'Henüz bahis yok. Ticarete başlayın!',
    noTransactions: 'Henüz işlem yok.',
    balanceOverTime: 'Zamana Göre Kâr/Zarar',
    betResults: 'Bahis Sonuçları',
    statusOpen: 'Açık',
    statusClosed: 'Kapalı',
    statusResolved: 'Çözüldü',
    statusCancelled: 'İptal edildi',
    loginFailed: 'Giriş başarısız oldu',
    registrationFailed: 'Kayıt başarısız oldu',
    passwordsNoMatch: 'Şifreler eşleşmiyor',
    passwordTooShort: 'Şifre en az 6 karakter olmalıdır',
    invalidBetAmount: 'Geçersiz bahis tutarı',
    marketCreationFailed: 'Pazar oluşturulamadı',
    betPlacementFailed: 'Bahis yapılamadı',
    welcomeMessage: 'Tekrar hoş geldiniz!',
    accountCreated: 'Scherenmarket\'e hoş geldiniz!',
    marketCreated: 'Pazar başarıyla oluşturuldu!',
    betPlaced: 'Bahis yapıldı',
    marketResolvedSuccess: 'Pazar başarıyla çözüldü',
    marketCancelledSuccess: 'Market iptal edildi, bahisler iade edildi',
    friendRequestSent: 'Arkadaşlık isteği gönderildi',
    friendRequestAccepted: 'Arkadaşlık isteği kabul edildi',
    friendRemoved: 'Arkadaş kaldırıldı',
    groupCreated: 'Grup oluşturuldu',
    categoryCreated: 'Kategori oluşturuldu',
    isTieredBet: 'Kademeli Bahis Oluştur',
    tieredOptions: 'Kademeli Bahis Seçenekleri',
    titleTemplate: 'Başlık Şablonu (Yer tutucu olarak (VALUE) kullanın)',
    titleTemplatePlaceholder: 'Bitcoin (VALUE) €\'nun üzerinde olacak mı?',
    thresholdMode: 'Eşik Giriş Modu',
    thresholdModeRange: 'Aralık (Başlangıç, Bitiş, Adım)',
    thresholdModeManual: 'Manuel Liste (Virgülle ayrılmış)',
    startValue: 'Başlangıç Değeri',
    endValue: 'Bitiş Değeri',
    stepSize: 'Adım Boyutu / Aralığı',
    manualThresholds: 'Eşikler (ör. 2000, 5000, 10000)',
    manualThresholdsPlaceholder: 'Eşikleri virgülle ayırarak girin...',
    invalidThresholds: 'Lütfen geçerli eşik değerleri girin.',
    tieredMarkets: 'Bu serideki eşikler',
    threshold: 'Eşik',
    currentTier: 'Mevcut Seviye',
    minBetAmount: 'Minimum Bahis Tutarı (€)',
    minBetAmountPlaceholder: 'örneğin 5',
    minBetAmountHint: 'Ev sahibi başlangıç ​​bahis tutarını belirleyebilir. Maksimum 50 €.',
    maxBetError: 'Bahis tutarı 50,00 €\'dan fazla olamaz.',
  },
  ru: {
    // --- Landing (auto-added) ---
    landingTag: 'Прогнозы среди друзей',
    landingHead: 'Прогнозируйте вместе. Побеждайте вместе.',
    landingSub: 'Scherenmarket — ваша частная платформа прогнозов. Вступайте в организацию, создавайте ставки да/нет и соревнуйтесь с друзьями.',
    landingReg: 'Бесплатная регистрация',
    landingLogin: 'Войти',
    landingHaveAcc: 'Уже с нами?',
    f1t: 'Частные организации',
    f1d: 'Ваши собственные пространства — ставки видит только ваша группа.',
    f2t: 'Создавайте ставки',
    f2d: 'Прогнозы да/нет на что угодно.',
    f3t: 'Честный расчёт',
    f3d: 'Игровые деньги или реальный расчёт через PayPal — решаете вы.',
    landingFooter: 'Рынок прогнозов для групп друзей',
    // --- Organizations & Announcements (auto-added) ---
    orgsTitle: 'Организации',
    orgsSubtitle: 'Вступи в организацию, чтобы видеть её ставки и участвовать. Можно состоять в нескольких сразу.',
    orgsSearch: 'Поиск организации…',
    orgsCreateBtn: 'Создать',
    orgsNoneFound: 'Организация не найдена.',
    orgMemberBadge: 'Участник',
    orgRequestedBadge: 'Заявка отправлена',
    orgAcceptedBadge: 'Принята',
    orgHostBadge: 'Хост',
    orgMembersWord: 'участников',
    orgMemberWord: 'участник',
    orgViewMembers: 'смотреть',
    orgJoinBtn: 'Вступить',
    orgJoinCode: 'Код доступа',
    orgEnterCode: 'Введите код доступа.',
    orgRequestJoin: 'Подать заявку',
    orgRequestsBtn: 'Заявки',
    orgEditBtn: 'Изменить',
    orgLeaveBtn: 'Покинуть',
    orgLeaveTitle: 'Покинуть организацию?',
    orgLeaveDesc: 'Вы больше не увидите её ставки, и, возможно, придётся вступать заново.',
    orgJoined: 'Вы вступили в организацию.',
    orgJoinFailed: 'Не удалось вступить.',
    orgRequestSent: 'Заявка отправлена — хост должен её одобрить.',
    orgRequestFailed: 'Ошибка заявки.',
    orgLeft: 'Вы покинули организацию.',
    orgLeaveFailed: 'Не удалось выйти.',
    orgLoadFailed: 'Не удалось загрузить организации.',
    orgRequestsLoadFailed: 'Не удалось загрузить заявки.',
    orgApprovedToast: 'Вступление одобрено.',
    orgRejectedToast: 'Заявка отклонена.',
    orgActionFailed: 'Действие не выполнено.',
    orgCreateTitle: 'Создать организацию',
    orgCreateDesc: 'Вы автоматически станете хостом новой организации.',
    orgNameLabel: 'Название',
    orgNameRequired: 'Введите название.',
    orgDescLabel: 'Описание',
    orgDescPlaceholder: 'О чём это?',
    orgImageLabel: 'URL изображения',
    orgImageOptional: 'URL изображения (необязательно)',
    orgPolicyLabel: 'Вступление',
    policyBoth: 'Код или заявка',
    policyCode: 'Только код',
    policyRequest: 'Только заявка',
    orgPaypalBilling: 'Расчёты PayPal',
    orgPlayMoney: 'Игровые деньги',
    orgCreated: 'Организация создана.',
    orgCreateFailed: 'Не удалось создать.',
    orgUpdated: 'Организация обновлена.',
    orgSaveFailed: 'Не удалось сохранить.',
    orgEditTitle: 'Изменить организацию',
    orgMembersTitle: 'Участники',
    orgMembersLoadFailed: 'Не удалось загрузить участников.',
    orgRemoveMemberTitle: 'Удалить участника?',
    orgRemoveMemberDesc: 'Этот человек потеряет доступ к организации.',
    orgMemberRemoved: 'Участник удалён.',
    orgRemoveFailed: 'Не удалось удалить.',
    orgNoRequests: 'Нет ожидающих заявок.',
    approveBtn: 'Принять',
    rejectBtn: 'Отклонить',
    removeBtn: 'Удалить',
    orgAcceptedInfo: 'Ваша заявка принята.',
    orgFinishPaypal: 'Добавьте ссылку PayPal, чтобы завершить вступление.',
    orgFinishJoin: 'Завершите вступление.',
    orgJoinWithPaypal: 'Вступить с PayPal',
    orgCompleteJoin: 'Завершить вступление',
    orgPaypalRequired: 'Требуется ссылка PayPal.',
    announcementClose: 'Закрыть объявление',
    coins: '€',
    balance: 'Прибыль/Убыток',
    netProfitLoss: 'Прибыль/Убыток',
    loading: 'Загрузка...',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    save: 'Сохранить',
    saving: 'Сохранение...',
    saveChanges: 'Сохранить изменения',
    delete: 'Удалить',
    edit: 'Редактировать',
    back: 'Назад',
    viewAll: 'Посмотреть все',
    search: 'Поиск',
    add: 'Добавить',
    remove: 'Удалить',
    create: 'Создать',
    previous: 'Предыдущий',
    next: 'Далее',
    welcomeBack: 'Шеренмаркет',
    signInToAccount: 'Войти',
    email: 'Электронная почта или имя пользователя',
    password: 'Пароль',
    signIn: 'Войти',
    signingIn: 'Вход в систему...',
    noAccount: 'Дон',
    createOne: 'Создать один',
    createAccount: 'Создать учетную запись',
    joinScherenmarket: 'Присоединяйтесь',
    username: 'Имя пользователя',
    confirmPassword: 'Подтвердите пароль',
    creatingAccount: 'Создание учетной записи...',
    hasAccount: 'У вас уже есть аккаунт?',
    startWithEuro: 'Вы начинаете с',
    canGoNegative: 'Вы начинаете с 0 € — ставьте столько, сколько хотите!',
    startingCapital: 'Стартовый капитал: 0 €',
    markets: 'Рынки',
    dashboard: 'Панель управления',
    profile: 'Профиль',
    logout: 'Выход из системы',
    language: 'Язык',
    friends: 'Друзья',
    groups: 'Группы',
    toggleTheme: 'Переключить тему',
    settlements: 'Платежи и выигрыши',
    toPay: 'Платить',
    toConfirm: 'Подтвердить получение',
    wonBetsOverview: 'Выигранные ставки',
    settlementHistory: 'История платежей',
    noPayoutsToPay: 'Никаких непогашенных долгов по ставкам. Отличная работа!',
    noPayoutsToConfirm: 'Нет ожидающих платежей для подтверждения.',
    noWonBetsYet: 'Выигранных ставок пока нет.',
    noPayoutHistory: 'Истории платежей пока нет.',
    amountToPay: 'Сумма',
    payee: 'Получатель платежа',
    payer: 'Плательщик',
    openPaypal: 'Оплатить через PayPal',
    confirmReceipt: 'Подтвердите получение',
    receiptConfirmed: 'Получение подтверждено!',
    statusPending: 'Ожидается',
    statusConfirmed: 'Подтверждено',
    copied: 'Скопировано!',
    copyInfo: 'Копировать информацию',
    pendingSettlementsAlert: 'У вас есть незавершенные расчеты! Пожалуйста, проверьте ваши платежи.',
    welcomeBackUser: 'С возвращением,',
    tradingOverview: 'Здесь',
    createMarket: 'Создать рынок',
    activeBets: 'Активные ставки',
    activeWager: 'Активная ставка',
    totalBets: 'Всего ставок',
    winRate: 'Процент побед',
    hotMarkets: 'Горячие рынки',
    yourOpenBets: 'Ваши открытые ставки',
    noOpenBets: 'Никаких открытых ставок. Найдите рынок, чтобы начать торговать!',
    leaderboard: 'Таблица лидеров',
    topTraders: 'Лучшие трейдеры',
    bottomTraders: 'Нижние трейдеры',
    browseMarkets: 'Рынки',
    browseBet: 'Просматривайте и делайте ставки на прогнозы',
    searchMarkets: 'Поиск рынков...',
    all: 'Все',
    noMarketsFound: 'Рынки не найдены',
    noMarketsMatch: 'Ни один рынок не соответствует',
    beFirstToCreate: 'Будьте первым, кто создаст рынок!',
    backToMarkets: 'Вернуться к рынкам',
    marketNotFound: 'Рынок не найден',
    by: 'по',
    ends: 'Заканчивается',
    bets: 'ставки',
    pool: 'бассейн',
    timeRemaining: 'Оставшееся время',
    days: 'Дни',
    hours: 'Часы',
    mins: 'Мин.',
    secs: 'Секунды',
    yes: 'ДА',
    no: 'НЕТ',
    betYes: 'СТАВЬ ДА',
    betNo: 'СТАВКА НЕТ',
    resolveMarket: 'Решить рынок',
    cancelMarket: 'Отменить рынок',
    cancelMarketConfirm: 'Неужели отменить этот рынок? Все ставки будут возвращены.',
    yourBets: 'Ваши ставки',
    pending: 'в ожидании',
    won: 'выиграл',
    lost: 'потерянный',
    refunded: 'возвращен',
    potential: 'Потенциал',
    ended: 'Закончено',
    visibility: 'Видимость',
    visibilityPublic: 'Общественный',
    visibilityEmailDomain: 'Только домен электронной почты',
    visibilitySpecificUsers: 'Только определенные пользователи',
    visibilityGroup: 'Только группа',
    emailDomain: 'Домен электронной почты (например, stud.uni-goettingen.de)',
    selectUsers: 'Выберите пользователей',
    selectGroup: 'Выберите группу',
    category: 'Категория',
    categories: 'Категории',
    noCategory: 'Нет категории',
    createCategory: 'Создать категорию',
    achievements: 'Достижения',
    noAchievements: 'Достижения пока не разблокированы.',
    awardedAt: 'Награжден',
    categoryName: 'Название категории',
    tagUsers: 'Отмечайте пользователей',
    taggedUsers: 'Отмеченные пользователи',
    searchUsers: 'Поиск пользователей...',
    userSearch: 'Поиск пользователей',
    userProfile: 'Профиль пользователя',
    memberSince: 'Участник с',
    recentBets: 'Недавние ставки',
    friendsList: 'Список друзей',
    friendRequests: 'Запросы на добавление в друзья',
    addFriend: 'Добавить друга',
    removeFriend: 'Удалить друга',
    acceptRequest: 'Принять',
    rejectRequest: 'Отклонить',
    requestSent: 'Запрос отправлен',
    noFriends: 'Друзей пока нет',
    noPendingRequests: 'Нет ожидающих запросов',
    editNickname: 'Изменить псевдоним',
    setNickname: 'Установить псевдоним',
    nickname: 'Псевдоним',
    nicknameUpdated: 'Псевдоним успешно обновлен',
    myGroups: 'Мои группы',
    createGroup: 'Создать группу',
    groupName: 'Название группы',
    groupDescription: 'Описание',
    groupMembers: 'Члены',
    addMembers: 'Добавить участников',
    leaveGroup: 'Покинуть группу',
    noGroups: 'Группы пока нет',
    copyInviteLink: 'Скопировать ссылку-приглашение',
    copyLinkManually: 'Скопируйте ссылку вручную:',
    close: 'Закрыть',
    inviteLinkCopied: 'Ссылка для приглашения скопирована в буфер обмена!',
    failedToCopyInviteLink: 'Не удалось скопировать ссылку для приглашения.',
    groupJoined: 'Успешно присоединился к группе!',
    joiningGroup: 'Присоединяюсь к группе...',
    invalidInviteLink: 'Неверная ссылка для приглашения',
    alreadyMember: 'Вы уже являетесь участником этой группы',
    error: 'Ошибка',
    backToFriends: 'Вернуться к друзьям',
    placeBet: 'Сделать ставку',
    betAmount: 'Сумма ставки',
    yourBalance: 'Ваша прибыль/убыток',
    placingBet: 'Размещение...',
    betOn: 'Ставка на',
    selectWinner: 'Выберите выигрышный результат. Это действие невозможно отменить.',
    yesWon: 'ДА Выиграл',
    noWon: 'НЕТ Выиграл',
    marketResolved: 'Рынок решен',
    marketCancelled: 'Рынок отменен',
    winners: 'Победители',
    totalPayout: 'Общая выплата',
    winnersList: 'Список победителей',
    noWinners: 'Нет победителей',
    payout: 'Выплата',
    createAMarket: 'Создать рынок',
    createYesNo: 'Создайте рынок прогнозов «да/нет», на который другие смогут делать ставки.',
    questionTitle: 'Вопрос/Заголовок',
    questionPlaceholder: 'Достигнет ли Биткойн 100 тысяч долларов к концу 2024 года?',
    descriptionOptional: 'Описание (необязательно)',
    descriptionPlaceholder: 'Добавьте больше контекста к этому прогнозу...',
    endDateTime: 'Дата и время окончания',
    pickDateTime: 'Выберите дату и время',
    marketWillClose: 'Рынок в это время закроется',
    tipsTitle: 'Советы для хорошего рынка:',
    tip1: 'Сделайте вопрос ясным и недвусмысленным',
    tip2: 'Установите реалистичную дату окончания',
    tip3: 'Добавить описание для контекста',
    tip4: 'ты',
    creating: 'Создание...',
    transactions: 'Транзакции',
    betHistory: 'История ставок',
    noBetsYet: 'Ставок пока нет. Начни торговать!',
    noTransactions: 'Транзакций пока нет.',
    balanceOverTime: 'Прибыль/убыток с течением времени',
    betResults: 'Результаты ставок',
    statusOpen: 'Открыть',
    statusClosed: 'Закрыто',
    statusResolved: 'Решено',
    statusCancelled: 'Отменено',
    loginFailed: 'Не удалось войти',
    registrationFailed: 'Регистрация не удалась',
    passwordsNoMatch: 'Пароли не совпадают',
    passwordTooShort: 'Пароль должен быть не менее 6 символов',
    invalidBetAmount: 'Неверная сумма ставки',
    marketCreationFailed: 'Не удалось создать рынок',
    betPlacementFailed: 'Не удалось сделать ставку',
    welcomeMessage: 'Добро пожаловать обратно!',
    accountCreated: 'Добро пожаловать в Шеренмаркет!',
    marketCreated: 'Маркет успешно создан!',
    betPlaced: 'Ставка сделана',
    marketResolvedSuccess: 'Рынок успешно решен',
    marketCancelledSuccess: 'Рынок отменен, ставки возвращены',
    friendRequestSent: 'Запрос на добавление в друзья отправлен',
    friendRequestAccepted: 'Запрос на добавление в друзья принят',
    friendRemoved: 'Друг удален',
    groupCreated: 'Группа создана',
    categoryCreated: 'Категория создана',
    isTieredBet: 'Создать многоуровневую ставку',
    tieredOptions: 'Варианты многоуровневых ставок',
    titleTemplate: 'Шаблон заголовка (используйте (VALUE) в качестве заполнителя)',
    titleTemplatePlaceholder: 'Будет ли Биткойн превышать (VALUE) евро?',
    thresholdMode: 'Режим порогового ввода',
    thresholdModeRange: 'Диапазон (Начало, Конец, Шаг)',
    thresholdModeManual: 'Список вручную (через запятую)',
    startValue: 'Начальное значение',
    endValue: 'Конечная стоимость',
    stepSize: 'Размер шага/интервал',
    manualThresholds: 'Пороговые значения (например, 2000, 5000, 10000)',
    manualThresholdsPlaceholder: 'Введите пороговые значения через запятую...',
    invalidThresholds: 'Введите действительные пороговые значения.',
    tieredMarkets: 'Пороги в этой серии',
    threshold: 'Порог',
    currentTier: 'Текущий уровень',
    minBetAmount: 'Минимальная сумма ставки (€)',
    minBetAmountPlaceholder: 'например 5',
    minBetAmountHint: 'Хозяин может установить начальную сумму ставки. Максимум 50 €.',
    maxBetError: 'Сумма ставки не может превышать 50,00 €.',
  },
  zh: {
    // --- Landing (auto-added) ---
    landingTag: '朋友间的预测',
    landingHead: '一起预测。一起赢。',
    landingSub: 'Scherenmarket 是你的私人预测平台。加入组织，创建是/否对赌，与朋友一较高下。',
    landingReg: '免费注册',
    landingLogin: '登录',
    landingHaveAcc: '已有账号？',
    f1t: '私密组织',
    f1d: '专属空间——只有你的群组能看到对赌。',
    f2t: '创建对赌',
    f2d: '对任何事进行是/否预测。',
    f3t: '公平结算',
    f3d: '虚拟货币或真实 PayPal 结算——由你决定。',
    landingFooter: '面向朋友群组的预测市场',
    // --- Organizations & Announcements (auto-added) ---
    orgsTitle: '组织',
    orgsSubtitle: '加入组织即可查看并参与其中的对赌。你可以同时加入多个组织。',
    orgsSearch: '搜索组织…',
    orgsCreateBtn: '创建',
    orgsNoneFound: '未找到组织。',
    orgMemberBadge: '成员',
    orgRequestedBadge: '已发送申请',
    orgAcceptedBadge: '已通过',
    orgHostBadge: '管理员',
    orgMembersWord: '名成员',
    orgMemberWord: '名成员',
    orgViewMembers: '查看',
    orgJoinBtn: '加入',
    orgJoinCode: '加入代码',
    orgEnterCode: '请输入加入代码。',
    orgRequestJoin: '申请加入',
    orgRequestsBtn: '申请',
    orgEditBtn: '编辑',
    orgLeaveBtn: '退出',
    orgLeaveTitle: '退出组织？',
    orgLeaveDesc: '你将无法再查看其对赌，可能需要重新加入。',
    orgJoined: '已加入组织。',
    orgJoinFailed: '加入失败。',
    orgRequestSent: '申请已发送——需管理员批准。',
    orgRequestFailed: '申请失败。',
    orgLeft: '已退出组织。',
    orgLeaveFailed: '退出失败。',
    orgLoadFailed: '无法加载组织。',
    orgRequestsLoadFailed: '无法加载申请。',
    orgApprovedToast: '已批准加入。',
    orgRejectedToast: '已拒绝申请。',
    orgActionFailed: '操作失败。',
    orgCreateTitle: '创建组织',
    orgCreateDesc: '你将自动成为新组织的管理员。',
    orgNameLabel: '名称',
    orgNameRequired: '请输入名称。',
    orgDescLabel: '描述',
    orgDescPlaceholder: '关于什么？',
    orgImageLabel: '图片链接',
    orgImageOptional: '图片链接（可选）',
    orgPolicyLabel: '加入方式',
    policyBoth: '代码或申请',
    policyCode: '仅限代码',
    policyRequest: '仅限申请',
    orgPaypalBilling: 'PayPal 结算',
    orgPlayMoney: '虚拟货币',
    orgCreated: '组织已创建。',
    orgCreateFailed: '创建失败。',
    orgUpdated: '组织已更新。',
    orgSaveFailed: '保存失败。',
    orgEditTitle: '编辑组织',
    orgMembersTitle: '成员',
    orgMembersLoadFailed: '无法加载成员。',
    orgRemoveMemberTitle: '移除成员？',
    orgRemoveMemberDesc: '该成员将失去此组织的访问权限。',
    orgMemberRemoved: '成员已移除。',
    orgRemoveFailed: '移除失败。',
    orgNoRequests: '暂无待处理申请。',
    approveBtn: '批准',
    rejectBtn: '拒绝',
    removeBtn: '移除',
    orgAcceptedInfo: '你的申请已被接受。',
    orgFinishPaypal: '添加你的 PayPal 链接以完成加入。',
    orgFinishJoin: '完成加入。',
    orgJoinWithPaypal: '通过 PayPal 加入',
    orgCompleteJoin: '完成加入',
    orgPaypalRequired: '需要 PayPal 链接。',
    announcementClose: '关闭公告',
    coins: '€',
    balance: '利润/亏损',
    netProfitLoss: '利润/亏损',
    loading: '正在加载...',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    saving: '正在保存...',
    saveChanges: '保存更改',
    delete: '删除',
    edit: '编辑',
    back: '返回',
    viewAll: '查看全部',
    search: '搜索',
    add: '添加',
    remove: '删除',
    create: '创建',
    previous: '上一页',
    next: '下一步',
    welcomeBack: '舍伦市场',
    signInToAccount: '登录',
    email: '电子邮件或用户名',
    password: '密码',
    signIn: '登录',
    signingIn: '正在登录...',
    noAccount: '唐',
    createOne: '创建一个',
    createAccount: '创建帐户',
    joinScherenmarket: '加入',
    username: '用户名',
    confirmPassword: '确认密码',
    creatingAccount: '正在创建帐户...',
    hasAccount: '已经有帐户？',
    startWithEuro: '你开始于',
    canGoNegative: '您从 0 欧元开始 - 想要下注多少就下注多少！',
    startingCapital: '起始资金： 0 €',
    markets: '市场',
    dashboard: '仪表板',
    profile: '公司简介',
    logout: '退出',
    language: '语言',
    friends: '朋友',
    groups: '团体',
    toggleTheme: '切换主题',
    settlements: '付款和奖金',
    toPay: '付款',
    toConfirm: '确认收货',
    wonBetsOverview: '赢得投注',
    settlementHistory: '付款记录',
    noPayoutsToPay: '没有未偿还的赌债。干得好！',
    noPayoutsToConfirm: '没有待确认的付款。',
    noWonBetsYet: '还没有赢的赌注。',
    noPayoutHistory: '还没有付款历史。',
    amountToPay: '金额',
    payee: '收款人',
    payer: '付款人',
    openPaypal: '使用贝宝支付',
    confirmReceipt: '确认收货',
    receiptConfirmed: '已确认收货！',
    statusPending: '待定',
    statusConfirmed: '已确认',
    copied: '复制了！',
    copyInfo: '复制信息',
    pendingSettlementsAlert: '您有悬而未决的和解！请检查您的付款。',
    welcomeBackUser: '欢迎回来，',
    tradingOverview: '这里',
    createMarket: '创造市场',
    activeBets: '活跃投注',
    activeWager: '主动投注',
    totalBets: '总投注额',
    winRate: '胜率',
    hotMarkets: '热门市场',
    yourOpenBets: '您的未平仓投注',
    noOpenBets: '没有未平仓投注。找到市场开始交易！',
    leaderboard: '排行榜',
    topTraders: '顶级交易商',
    bottomTraders: '底部交易者',
    browseMarkets: '市场',
    browseBet: '浏览预测并下注',
    searchMarkets: '搜索市场...',
    all: '全部',
    noMarketsFound: '未找到市场',
    noMarketsMatch: '没有市场匹配',
    beFirstToCreate: '成为第一个创造市场的人！',
    backToMarkets: '返回市场',
    marketNotFound: '未找到市场',
    by: '通过',
    ends: '结束',
    bets: '赌注',
    pool: '泳池',
    timeRemaining: '剩余时间',
    days: '天数',
    hours: '时间',
    mins: '分钟',
    secs: '秒',
    yes: '是的',
    no: '否',
    betYes: '打赌是的',
    betNo: '赌不',
    resolveMarket: '解决市场',
    cancelMarket: '取消市场',
    cancelMarketConfirm: '真的取消这个市场吗？所有投注将被退还。',
    yourBets: '你的赌注',
    pending: '待定',
    won: '赢了',
    lost: '迷失了',
    refunded: '已退款',
    potential: '潜力',
    ended: '结束',
    visibility: '能见度',
    visibilityPublic: '公共',
    visibilityEmailDomain: '仅电子邮件域',
    visibilitySpecificUsers: '仅限特定用户',
    visibilityGroup: '仅限团体',
    emailDomain: '电子邮件域名（例如，stud.uni-goettingen.de）',
    selectUsers: '选择用户',
    selectGroup: '选择组',
    category: '类别',
    categories: '类别',
    noCategory: '没有类别',
    createCategory: '创建类别',
    achievements: '成就',
    noAchievements: '尚未解锁任何成就。',
    awardedAt: '授予于',
    categoryName: '类别名称',
    tagUsers: '标签用户',
    taggedUsers: '标记用户',
    searchUsers: '搜索用户...',
    userSearch: '搜索用户',
    userProfile: '用户资料',
    memberSince: '会员自',
    recentBets: '最近的投注',
    friendsList: '好友列表',
    friendRequests: '好友请求',
    addFriend: '添加好友',
    removeFriend: '删除好友',
    acceptRequest: '接受',
    rejectRequest: '拒绝',
    requestSent: '请求已发送',
    noFriends: '还没有朋友',
    noPendingRequests: '没有待处理的请求',
    editNickname: '编辑昵称',
    setNickname: '设置昵称',
    nickname: '昵称',
    nicknameUpdated: '昵称更新成功',
    myGroups: '我的群组',
    createGroup: '创建群组',
    groupName: '团体名称',
    groupDescription: '描述',
    groupMembers: '会员',
    addMembers: '添加成员',
    leaveGroup: '离开群组',
    noGroups: '还没有群组',
    copyInviteLink: '复制邀请链接',
    copyLinkManually: '手动复制链接：',
    close: '关闭',
    inviteLinkCopied: '邀请链接已复制到剪贴板！',
    failedToCopyInviteLink: '复制邀请链接失败',
    groupJoined: '成功加群！',
    joiningGroup: '正在加入群组...',
    invalidInviteLink: '邀请链接无效',
    alreadyMember: '您已经是该群组的成员',
    error: '错误',
    backToFriends: '返回朋友圈',
    placeBet: '下注',
    betAmount: '投注金额',
    yourBalance: '您的利润/损失',
    placingBet: '放置...',
    betOn: '下注',
    selectWinner: 'Select the winning outcome.此操作无法撤消。',
    yesWon: '是的赢了',
    noWon: '没有赢过',
    marketResolved: '市场解决',
    marketCancelled: '市场取消',
    winners: '获奖者',
    totalPayout: '总支出',
    winnersList: '获奖者名单',
    noWinners: '没有赢家',
    payout: '支出',
    createAMarket: '创建市场',
    createYesNo: '创建一个是/否预测市场供其他人下注',
    questionTitle: '问题/标题',
    questionPlaceholder: '到 2024 年底，比特币会达到 10 万美元吗？',
    descriptionOptional: '描述（可选）',
    descriptionPlaceholder: '添加有关此预测的更多背景信息...',
    endDateTime: '结束日期和时间',
    pickDateTime: '选择日期和时间',
    marketWillClose: '市场此时将关闭',
    tipsTitle: '良好市场的秘诀：',
    tip1: '让问题清晰明确',
    tip2: '设定一个现实的结束日期',
    tip3: '添加上下文描述',
    tip4: '你',
    creating: '创造...',
    transactions: '交易',
    betHistory: '投注历史',
    noBetsYet: '还没有下注。开始交易！',
    noTransactions: '还没有交易。',
    balanceOverTime: '随时间变化的损益',
    betResults: '投注结果',
    statusOpen: '打开',
    statusClosed: '关闭',
    statusResolved: '已解决',
    statusCancelled: '取消',
    loginFailed: '登录失败',
    registrationFailed: '注册失败',
    passwordsNoMatch: '密码不匹配',
    passwordTooShort: '密码必须至少为 6 个字符',
    invalidBetAmount: '投注金额无效',
    marketCreationFailed: '未能创造市场',
    betPlacementFailed: '下注失败',
    welcomeMessage: '欢迎回来！',
    accountCreated: '欢迎来到谢伦市场！',
    marketCreated: '市场创建成功！',
    betPlaced: '下注',
    marketResolvedSuccess: '市场化解成功',
    marketCancelledSuccess: '盘口取消，投注退款',
    friendRequestSent: '好友请求已发送',
    friendRequestAccepted: '已接受好友请求',
    friendRemoved: '好友已删除',
    groupCreated: '群组已创建',
    categoryCreated: '类别已创建',
    isTieredBet: '创建分级投注',
    tieredOptions: '分级投注选项',
    titleTemplate: '标题模板（使用 (VALUE) 作为占位符）',
    titleTemplatePlaceholder: '比特币会高于（VALUE）欧元吗？',
    thresholdMode: '阈值输入模式',
    thresholdModeRange: '范围（开始、结束、步长）',
    thresholdModeManual: '手册列表（逗号分隔）',
    startValue: '起始值',
    endValue: '最终值',
    stepSize: '步长/间隔',
    manualThresholds: '阈值（例如，2000、5000、10000）',
    manualThresholdsPlaceholder: '输入以逗号分隔的阈值...',
    invalidThresholds: '请输入有效的阈值。',
    tieredMarkets: '本系列的阈值',
    threshold: '阈值',
    currentTier: '当前等级',
    minBetAmount: '最低投注金额（欧元）',
    minBetAmountPlaceholder: '例如5',
    minBetAmountHint: '主持人可以设置起始投注金额。最多 50 欧元。',
    maxBetError: '投注金额不能超过 50.00 欧元。',
  },
  ja: {
    // --- Landing (auto-added) ---
    landingTag: '仲間内の予測',
    landingHead: '一緒に予測。一緒に勝つ。',
    landingSub: 'Scherenmarket はあなたの非公開の予測プラットフォームです。組織に参加し、Yes/No の賭けを作り、仲間と競いましょう。',
    landingReg: '無料で登録',
    landingLogin: 'ログイン',
    landingHaveAcc: 'すでに参加済み？',
    f1t: '非公開の組織',
    f1d: '自分たちだけの空間——賭けはグループ内だけ。',
    f2t: '賭けを作成',
    f2d: 'あらゆることに Yes/No 予測。',
    f3t: '公平に精算',
    f3d: '仮想マネーか実際の PayPal 精算か——あなた次第。',
    landingFooter: '仲間グループのための予測市場',
    // --- Organizations & Announcements (auto-added) ---
    orgsTitle: '組織',
    orgsSubtitle: '組織に参加すると、その賭けを見て参加できます。複数の組織に同時に所属できます。',
    orgsSearch: '組織を検索…',
    orgsCreateBtn: '作成',
    orgsNoneFound: '組織が見つかりません。',
    orgMemberBadge: 'メンバー',
    orgRequestedBadge: 'リクエスト送信済み',
    orgAcceptedBadge: '承認済み',
    orgHostBadge: 'ホスト',
    orgMembersWord: '人のメンバー',
    orgMemberWord: '人のメンバー',
    orgViewMembers: '表示',
    orgJoinBtn: '参加',
    orgJoinCode: '参加コード',
    orgEnterCode: '参加コードを入力してください。',
    orgRequestJoin: '参加をリクエスト',
    orgRequestsBtn: 'リクエスト',
    orgEditBtn: '編集',
    orgLeaveBtn: '退会',
    orgLeaveTitle: '組織を退会しますか？',
    orgLeaveDesc: 'その賭けは表示されなくなり、再参加が必要になる場合があります。',
    orgJoined: '組織に参加しました。',
    orgJoinFailed: '参加に失敗しました。',
    orgRequestSent: 'リクエストを送信しました。ホストの承認が必要です。',
    orgRequestFailed: 'リクエストに失敗しました。',
    orgLeft: '組織を退会しました。',
    orgLeaveFailed: '退会に失敗しました。',
    orgLoadFailed: '組織を読み込めませんでした。',
    orgRequestsLoadFailed: 'リクエストを読み込めませんでした。',
    orgApprovedToast: '参加を承認しました。',
    orgRejectedToast: 'リクエストを拒否しました。',
    orgActionFailed: '操作に失敗しました。',
    orgCreateTitle: '組織を作成',
    orgCreateDesc: '新しい組織のホストに自動的になります。',
    orgNameLabel: '名前',
    orgNameRequired: '名前を入力してください。',
    orgDescLabel: '説明',
    orgDescPlaceholder: 'どんな内容ですか？',
    orgImageLabel: '画像URL',
    orgImageOptional: '画像URL（任意）',
    orgPolicyLabel: '参加方法',
    policyBoth: 'コードまたはリクエスト',
    policyCode: 'コードのみ',
    policyRequest: 'リクエストのみ',
    orgPaypalBilling: 'PayPal精算',
    orgPlayMoney: '仮想マネー',
    orgCreated: '組織を作成しました。',
    orgCreateFailed: '作成に失敗しました。',
    orgUpdated: '組織を更新しました。',
    orgSaveFailed: '保存に失敗しました。',
    orgEditTitle: '組織を編集',
    orgMembersTitle: 'メンバー',
    orgMembersLoadFailed: 'メンバーを読み込めませんでした。',
    orgRemoveMemberTitle: 'メンバーを削除しますか？',
    orgRemoveMemberDesc: 'この人はこの組織にアクセスできなくなります。',
    orgMemberRemoved: 'メンバーを削除しました。',
    orgRemoveFailed: '削除に失敗しました。',
    orgNoRequests: '保留中のリクエストはありません。',
    approveBtn: '承認',
    rejectBtn: '拒否',
    removeBtn: '削除',
    orgAcceptedInfo: 'リクエストが承認されました。',
    orgFinishPaypal: '参加を完了するには PayPal リンクを追加してください。',
    orgFinishJoin: '参加を完了してください。',
    orgJoinWithPaypal: 'PayPalで参加',
    orgCompleteJoin: '参加を完了',
    orgPaypalRequired: 'PayPalリンクが必要です。',
    announcementClose: 'お知らせを閉じる',
    coins: '€',
    balance: '損益',
    netProfitLoss: '損益',
    loading: '読み込み中...',
    cancel: 'キャンセル',
    confirm: '確認する',
    save: '保存',
    saving: '保存中...',
    saveChanges: '変更を保存',
    delete: '削除',
    edit: '編集',
    back: '戻る',
    viewAll: 'すべて見る',
    search: '検索',
    add: '追加',
    remove: '削除する',
    create: '作成',
    previous: '前へ',
    next: '次へ',
    welcomeBack: 'シェレンマーケット',
    signInToAccount: 'サインイン',
    email: 'メールアドレスまたはユーザー名',
    password: 'パスワード',
    signIn: 'サインイン',
    signingIn: 'サインイン中...',
    noAccount: 'ドン',
    createOne: '作成する',
    createAccount: 'アカウントの作成',
    joinScherenmarket: '参加する',
    username: 'ユーザー名',
    confirmPassword: 'パスワードの確認',
    creatingAccount: 'アカウントを作成しています...',
    hasAccount: 'すでにアカウントをお持ちですか?',
    startWithEuro: 'から始めます',
    canGoNegative: '0 ユーロからスタート - 好きなだけ賭けましょう!',
    startingCapital: '開始資本: 0 €',
    markets: '市場',
    dashboard: 'ダッシュボード',
    profile: 'プロフィール',
    logout: 'ログアウト',
    language: '言語',
    friends: '友達',
    groups: 'グループ',
    toggleTheme: 'テーマの切り替え',
    settlements: '支払いと賞金',
    toPay: '支払う',
    toConfirm: '受信確認',
    wonBetsOverview: '勝った賭け',
    settlementHistory: '支払い履歴',
    noPayoutsToPay: '未払いの賭け金はありません。よくやった！',
    noPayoutsToConfirm: '確認する保留中の支払いはありません。',
    noWonBetsYet: 'まだ勝ちの賭けはありません。',
    noPayoutHistory: 'まだ支払い履歴がありません。',
    amountToPay: '金額',
    payee: '受取人',
    payer: '支払者',
    openPaypal: 'PayPalで支払う',
    confirmReceipt: '受信確認',
    receiptConfirmed: '受け取り確認されました！',
    statusPending: '保留中',
    statusConfirmed: '確認済み',
    copied: 'コピーしました！',
    copyInfo: '情報をコピーする',
    pendingSettlementsAlert: '保留中の和解があります!お支払いをご確認ください。',
    welcomeBackUser: 'おかえりなさい、',
    tradingOverview: 'ここ',
    createMarket: '市場の創造',
    activeBets: 'アクティブなベット',
    activeWager: 'アクティブな賭け方',
    totalBets: '合計ベット数',
    winRate: '勝率',
    hotMarkets: 'ホットマーケット',
    yourOpenBets: 'あなたのオープンベット',
    noOpenBets: 'オープンベットはありません。取引を開始する市場を見つけてください!',
    leaderboard: 'リーダーボード',
    topTraders: 'トップトレーダー',
    bottomTraders: '底辺トレーダー',
    browseMarkets: '市場',
    browseBet: '予想を閲覧して賭ける',
    searchMarkets: 'マーケットを検索...',
    all: 'すべて',
    noMarketsFound: 'マーケットが見つかりません',
    noMarketsMatch: '一致する市場はありません',
    beFirstToCreate: '誰よりも早くマーケットを作りましょう！',
    backToMarkets: 'マーケットに戻る',
    marketNotFound: 'マーケットが見つかりません',
    by: 'によって',
    ends: '終わり',
    bets: '賭ける',
    pool: 'プール',
    timeRemaining: '残り時間',
    days: '日数',
    hours: '営業時間',
    mins: '分',
    secs: '秒',
    yes: 'はい',
    no: 'いいえ',
    betYes: 'はいに賭けてください',
    betNo: '賭けない',
    resolveMarket: 'マーケットを解決する',
    cancelMarket: 'マーケットのキャンセル',
    cancelMarketConfirm: '本当にこの市場を中止しますか？すべての賭け金は返金されます。',
    yourBets: 'あなたの賭け',
    pending: '保留中',
    won: '勝った',
    lost: '失われた',
    refunded: '返金された',
    potential: '可能性',
    ended: '終了しました',
    visibility: '可視性',
    visibilityPublic: '公共',
    visibilityEmailDomain: 'メールドメインのみ',
    visibilitySpecificUsers: '特定のユーザーのみ',
    visibilityGroup: 'グループのみ',
    emailDomain: '電子メール ドメイン (例: stack.uni-goettingen.de)',
    selectUsers: 'ユーザーの選択',
    selectGroup: 'グループを選択',
    category: 'カテゴリ',
    categories: 'カテゴリー',
    noCategory: 'カテゴリなし',
    createCategory: 'カテゴリの作成',
    achievements: '業績',
    noAchievements: 'まだロック解除された実績はありません。',
    awardedAt: '受賞日',
    categoryName: 'カテゴリ名',
    tagUsers: 'ユーザーにタグを付ける',
    taggedUsers: 'タグ付けされたユーザー',
    searchUsers: 'ユーザーを検索...',
    userSearch: 'ユーザーの検索',
    userProfile: 'ユーザープロフィール',
    memberSince: '以来のメンバー',
    recentBets: '最近の賭け',
    friendsList: '友達リスト',
    friendRequests: '友達リクエスト',
    addFriend: '友達を追加',
    removeFriend: '友達を削除する',
    acceptRequest: '受け入れる',
    rejectRequest: '拒否する',
    requestSent: 'リクエストを送信しました',
    noFriends: 'まだ友達がいません',
    noPendingRequests: '保留中のリクエストはありません',
    editNickname: 'ニックネームの編集',
    setNickname: 'ニックネームを設定する',
    nickname: 'ニックネーム',
    nicknameUpdated: 'ニックネームが正常に更新されました',
    myGroups: '私のグループ',
    createGroup: 'グループの作成',
    groupName: 'グループ名',
    groupDescription: '説明',
    groupMembers: 'メンバー',
    addMembers: 'メンバーを追加する',
    leaveGroup: 'グループを離れる',
    noGroups: 'まだグループがありません',
    copyInviteLink: '招待リンクをコピーする',
    copyLinkManually: 'リンクを手動でコピーします。',
    close: '閉じる',
    inviteLinkCopied: '招待リンクがクリップボードにコピーされました。',
    failedToCopyInviteLink: '招待リンクをコピーできませんでした',
    groupJoined: '無事にグループに参加できました！',
    joiningGroup: 'グループに参加しています...',
    invalidInviteLink: '無効な招待リンクです',
    alreadyMember: 'あなたはすでにこのグループのメンバーです',
    error: 'エラー',
    backToFriends: '友達に戻る',
    placeBet: 'ベットをする',
    betAmount: 'ベット額',
    yourBalance: 'あなたの利益/損失',
    placingBet: '配置中...',
    betOn: '賭けます',
    selectWinner: '勝利結果を選択します。この操作は元に戻すことができません。',
    yesWon: 'はい、勝ちました',
    noWon: '勝てませんでした',
    marketResolved: '市場解決済み',
    marketCancelled: 'マーケット中止',
    winners: '勝者',
    totalPayout: '総支払額',
    winnersList: '受賞者リスト',
    noWinners: '勝者なし',
    payout: '支払い',
    createAMarket: 'マーケットを作る',
    createYesNo: '他の人が賭けられる「はい/いいえ」予測マーケットを作成する',
    questionTitle: '質問/タイトル',
    questionPlaceholder: 'ビットコインは2024年末までに10万ドルに達するでしょうか？',
    descriptionOptional: '説明 (オプション)',
    descriptionPlaceholder: 'この予測に関するコンテキストをさらに追加...',
    endDateTime: '終了日時',
    pickDateTime: '日付と時刻を選択してください',
    marketWillClose: '市場はこの時間で閉まります',
    tipsTitle: '良い市場を作るためのヒント:',
    tip1: '質問を明確かつ明確にする',
    tip2: '現実的な終了日を設定する',
    tip3: 'コンテキストの説明を追加する',
    tip4: 'あなた',
    creating: '作成中...',
    transactions: '取引',
    betHistory: 'ベット履歴',
    noBetsYet: 'まだ賭けはありません。取引を始めましょう！',
    noTransactions: 'まだ取引はありません。',
    balanceOverTime: '経時的な損益',
    betResults: 'ベット結果',
    statusOpen: '開く',
    statusClosed: '閉店',
    statusResolved: '解決済み',
    statusCancelled: 'キャンセルされました',
    loginFailed: 'ログインに失敗しました',
    registrationFailed: '登録に失敗しました',
    passwordsNoMatch: 'パスワードが一致しません',
    passwordTooShort: 'パスワードは6文字以上である必要があります',
    invalidBetAmount: '無効な賭け金',
    marketCreationFailed: 'マーケットの作成に失敗しました',
    betPlacementFailed: '賭けに失敗しました',
    welcomeMessage: 'おかえりなさい！',
    accountCreated: 'シェレンマーケットへようこそ！',
    marketCreated: 'マーケットが正常に作成されました。',
    betPlaced: '賭けた',
    marketResolvedSuccess: '市場は無事に解決されました',
    marketCancelledSuccess: 'マーケットはキャンセルされ、賭け金は返金されました',
    friendRequestSent: 'フレンドリクエストを送信しました',
    friendRequestAccepted: '友達リクエスト受け付けました',
    friendRemoved: '友達が削除されました',
    groupCreated: 'グループが作成されました',
    categoryCreated: 'カテゴリが作成されました',
    isTieredBet: '段階的ベットの作成',
    tieredOptions: '段階的ベットオプション',
    titleTemplate: 'タイトル テンプレート (プレースホルダーとして (VALUE) を使用)',
    titleTemplatePlaceholder: 'ビットコインは (VALUE) ユーロを超えるでしょうか?',
    thresholdMode: '閾値入力モード',
    thresholdModeRange: '範囲 (開始、終了、ステップ)',
    thresholdModeManual: 'マニュアルリスト（カンマ区切り）',
    startValue: '開始値',
    endValue: '終了値',
    stepSize: 'ステップサイズ/間隔',
    manualThresholds: 'しきい値 (例: 2000、5000、10000)',
    manualThresholdsPlaceholder: 'しきい値をカンマで区切って入力してください...',
    invalidThresholds: '有効なしきい値を入力してください。',
    tieredMarkets: 'このシリーズのしきい値',
    threshold: 'しきい値',
    currentTier: '現在の階層',
    minBetAmount: 'Minimum Bet Amount (€)',
    minBetAmountPlaceholder: '例: 5',
    minBetAmountHint: 'ホストは開始ベット額を設定できます。最大50ユーロ。',
    maxBetError: 'ベット額は 50.00 ユーロを超えることはできません。',
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('scherenmarket-lang') || 'de';
  });

  useEffect(() => {
    localStorage.setItem('scherenmarket-lang', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['de']?.[key] || translations['en']?.[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => {
      const codes = Object.keys(LANGUAGES);
      const idx = codes.indexOf(prev);
      return codes[(idx + 1) % codes.length];
    });
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, translations, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};